/**
 * Product Customizer – feature sections for easier management.
 */
(function () {
  var C = window.PRODUCT_CUSTOMIZER_CONFIG;
  if (!C) return;
  document.getElementById("originalUniqueKey").value = Date.now();

  var plushMaxImageBytes = 15 * 1000 * 1000;
  var plushMaxImageSizeMessage =
    "Maximum file size is 15 MB (15,000,000 bytes) per image. Please compress or choose a smaller file.";
  var plushMaxImageSizeUnknownMessage =
    "Could not read a valid file size for this image (15 MB max). Try another file or export as JPEG/PNG.";

  function plushStep3FileSizeBytes(file) {
    if (!file) return NaN;
    var s = file.size;
    if (typeof s === "bigint") return Number(s);
    if (typeof s === "number") return s;
    return NaN;
  }

  function plushStep3RejectFileSize(file, inputEl) {
    var n = plushStep3FileSizeBytes(file);
    if (!Number.isFinite(n) || n <= 0) {
      alert(plushMaxImageSizeUnknownMessage);
      if (inputEl) inputEl.value = "";
      return true;
    }
    if (n > plushMaxImageBytes) {
      alert(plushMaxImageSizeMessage);
      if (inputEl) inputEl.value = "";
      return true;
    }
    return false;
  }

  /** Size-chart metafield: prefer explicit Liquid key (plush_product | json often drops metafields). */
  function getCuddleclonesOptionsValue() {
    if (
      C.cuddleclonesOptionsValue != null &&
      C.cuddleclonesOptionsValue !== undefined
    ) {
      return C.cuddleclonesOptionsValue;
    }
    try {
      var p = C.plushProduct;
      if (!p || !p.metafields || !p.metafields.cuddleclones) return null;
      var opts = p.metafields.cuddleclones.options;
      if (!opts || opts.value === undefined || opts.value === null) return null;
      return opts.value;
    } catch (e) {
      return null;
    }
  }

  var omsPlushDetails = C.omsPlushDetails;
  const omsHeader = {
    "api-token": omsPlushDetails[0].api_token,
    // 'ngrok-skip-browser-warning': 6024,
  };

  var showBar =
    C.progressBarVisible === true || C.progressBarVisible === "true";
  var displayVal = showBar ? "" : "none";
  var progressSection = document.querySelector(
    ".top-banner.progress-bar-container",
  );
  var progressMainNote = document.querySelector("section.page-main-note");
  if (progressSection)
    progressSection.style.setProperty("display", displayVal, "important");
  if (progressMainNote)
    progressMainNote.style.setProperty("display", displayVal, "important");
  const progressBarDisplay = document.querySelector(".progress-bar-display");
  if (progressBarDisplay)
    progressBarDisplay.style.setProperty(
      "display",
      showBar ? "block" : "none",
      "important",
    );
  var omsDetails = C.omsDetails;
  const header = {
    "api-token": omsDetails[0].api_token,
    // 'ngrok-skip-browser-warning': 6024,
  };

  const container = document.getElementById("productOptionsContainer");

  function normalizeMouthCaption(s) {
    if (s == null || s === "") return "";
    return String(s)
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\s+/g, " ")
      .trim();
  }

  function mouthLabelLinesForItem(item, index, totalCount) {
    var sub = item.subtitle || item.label_line2 || item.name_line2;
    var name = item.name != null ? String(item.name).trim() : "";
    var line1 = "";
    var line2 = "";
    if (name.indexOf("|") >= 0) {
      var parts = name.split("|").map(function (s) {
        return s.trim();
      });
      line1 = parts[0] || "";
      line2 = parts[1] || (sub ? String(sub).trim() : "");
    } else if (name.indexOf("\n") >= 0) {
      var lines = name.split(/\n/).map(function (s) {
        return s.trim();
      });
      line1 = lines[0] || "";
      line2 = lines[1] || (sub ? String(sub).trim() : "");
    } else if (sub) {
      line1 = name;
      line2 = String(sub).trim();
    } else if (totalCount === 3 && index >= 0 && index < 3) {
      var presets = [
        ["Closed Mouth", "No Tongue"],
        ["Closed Mouth", "With Tongue"],
        ["Open Mouth", "With Tongue"],
      ];
      line1 = presets[index][0];
      line2 = presets[index][1];
    } else {
      line1 = name;
      line2 = "";
    }
    return {
      line1: normalizeMouthCaption(line1),
      line2: normalizeMouthCaption(line2),
    };
  }

  /** Keys with display:true, Mouth first so layout matches “ear after mouth”. */
  function orderPetOptionPositions(petData) {
    var keys = Object.keys(petData).filter(function (k) {
      return petData[k] && petData[k].display;
    });
    var mouthIdx = -1;
    for (var i = 0; i < keys.length; i++) {
      if (/^mouth$/i.test(String(keys[i]).trim())) {
        mouthIdx = i;
        break;
      }
    }
    if (mouthIdx <= 0) return keys;
    var next = keys.slice();
    var m = next.splice(mouthIdx, 1)[0];
    return [m].concat(next);
  }

  function generateSection(title, imagesAndPositions) {
    let sizeData = getCuddleclonesOptionsValue();
    const sectionContainer = document.createElement("div");
    sectionContainer.className = "section-container";
    if (title === "Mouth" || title === "Body" || title === "Tail") {
      sectionContainer.classList.add("mouth-position-section");
    }

    if (imagesAndPositions && imagesAndPositions.length > 0) {
      const heading = document.createElement("div");
      heading.classList.add("section-heading");

      const Description = document.createElement("div");
      Description.classList.add("section-description");

      if (title === "Size") {
        heading.textContent = title;
        if (isSizeChartAvailable(sizeData)) {
          var popUpButton = document.createElement("p");
          popUpButton.textContent = "View Size Chart";
          popUpButton.setAttribute("tabindex", "0");
          popUpButton.classList.add("viewSizeChart");
          popUpButton.addEventListener("keydown", handleSizeChartKeyDown);
          popUpButton.addEventListener("click", function () {
            openPopup();
          });
          heading.appendChild(popUpButton);
        }
      } else {
        heading.textContent = "Select " + title + " Position";
        if (title === "Mouth") {
          Description.textContent = "Select your plush clone's mouth position";
        } else {
          Description.textContent =
            "Select your plush clone’s " + title + " Position";
        }
      }
      sectionContainer.appendChild(heading);
      sectionContainer.appendChild(Description);
    }

    const section = document.createElement("div");
    section.classList.add("productPositions", title.toLowerCase());

    sectionContainer.appendChild(section);
    container.appendChild(sectionContainer);

    if (imagesAndPositions && imagesAndPositions.length > 0) {
      generatePetImages(imagesAndPositions, section, title);
    }
  }

  function generatePetImages(imagesAndPositions, section, title) {
    imagesAndPositions.forEach((item, index) => {
      const positionTitle = title.toLowerCase();
      const div = document.createElement("div");
      const label = document.createElement("label");

      const radioInput = document.createElement("input");
      radioInput.setAttribute("type", "radio");
      radioInput.setAttribute("name", "properties[" + positionTitle + "]");
      radioInput.setAttribute("value", item.value);
      radioInput.setAttribute("id", positionTitle + "-position-" + index);
      radioInput.tabIndex = -1;

      if (title === "Size") {
        const sizeButton = document.createElement("button");
        // Untyped buttons default to type="submit" and this one lives inside
        // #customizer_form (action=/cart/add) — keep it inert.
        sizeButton.type = "button";
        sizeButton.classList.add("size-chart-button");
        sizeButton.setAttribute("id", "size-chart-button");
        sizeButton.textContent = item.name;

        const newDiv = document.createElement("div");
        newDiv.classList.add(title.toLowerCase() + "-label");
        newDiv.appendChild(sizeButton);
        label.appendChild(radioInput);
        label.appendChild(newDiv);

        sizeButton.addEventListener("click", (event) => {
          event.preventDefault();
          // Remove border from all images
          document.querySelectorAll(".size-label button").forEach((button) => {
            button.classList.remove("selected");
          });
          var closestInput = document
            .getElementById("size-chart-button")
            .closest("label")
            .querySelector('input[type="radio"]');
          closestInput.checked = true;
          sizeButton.classList.add("selected");
        });

        div.classList.add("size-chart-buttons");
        div.appendChild(label);
      } else {
        const img = document.createElement("img");
        img.src = item.src;
        img.alt = item.alt;
        var mouthLines = null;
        if (title === "Mouth") {
          mouthLines = mouthLabelLinesForItem(
            item,
            index,
            imagesAndPositions.length,
          );
          img.setAttribute(
            "aria-label",
            [mouthLines.line1, mouthLines.line2].filter(Boolean).join(" ") +
            " " +
            positionTitle +
            " position",
          );
        } else {
          img.setAttribute(
            "aria-label",
            `${positionTitle}position ${item.alt}`,
          );
        }

        img.setAttribute("tabindex", "0");
        img.addEventListener("keydown", handlePetPositionKeydown);

        const newDiv = document.createElement("div");
        newDiv.classList.add(
          title.toLowerCase() + "-label",
          "final-product-positions",
        );
        newDiv.appendChild(img);
        label.appendChild(radioInput);
        label.appendChild(newDiv);

        if (title === "Mouth" && mouthLines) {
          const labelP = document.createElement("p");
          labelP.classList.add("position-label-mouth", "position-label-mouth--step1");
          labelP.appendChild(document.createTextNode(mouthLines.line1 || ""));
          if (mouthLines.line2) {
            labelP.appendChild(document.createElement("br"));
            labelP.appendChild(document.createTextNode(mouthLines.line2));
          }
          label.appendChild(labelP);
        } else if (title === "Body") {
          const labelP = document.createElement("p");
          labelP.classList.add("position-label-mouth", "position-label-mouth--step1");
          labelP.textContent = item.name != null ? String(item.name) : "";
          label.appendChild(labelP);
        } else if (title === "Tail") {
          const labelP = document.createElement("p");
          labelP.classList.add("position-label-mouth");
          labelP.textContent = item.name != null ? String(item.name) : "";
          label.appendChild(labelP);
        } else {
          const p = document.createElement("p");
          p.classList.add("position-label");
          p.textContent = item.name;
          label.appendChild(p);
        }
        div.appendChild(label);

        function syncPositionImageSelected() {
          if (!radioInput.checked) return;
          var section = div.closest(".body-position-image");
          if (section) {
            section.querySelectorAll("img").forEach(function (im) {
              im.classList.remove("selected");
            });
          }
          img.classList.add("selected");
        }

        radioInput.addEventListener("change", syncPositionImageSelected);

        // Add click event listener to the image
        img.addEventListener("click", function () {
          var section = div.closest(".body-position-image");
          if (section) {
            section.querySelectorAll("img").forEach(function (im) {
              im.classList.remove("selected");
            });
          }
          img.classList.add("selected");
          radioInput.checked = true;
        });

        div.classList.add("body-position-image");
      }
      section.appendChild(div);
    });
  }

  let selectedPetTypeName = "";
  var selectedBreedValue;
  var productOptionDisplay = false;
  try {
    var _po =
      C.customizer && C.customizer[4] && C.customizer[4].product_options;
    productOptionDisplay = _po && _po[2] ? !!_po[2].display : false;
  } catch (e) {
    productOptionDisplay = false;
  }

  function plushApplyBreedSelectSideEffects(select) {
    if (!select) return;
    selectedBreedValue = select.value;
    var mixed = document.querySelector(".otherMixedDiv");
    if (mixed) {
      mixed.style.display = selectedBreedValue === "Other/Mixed" ? "block" : "none";
    }
    var selectedOption = select.options[select.selectedIndex];
    var hasBreathingBoxValue =
      selectedOption && selectedOption.getAttribute("data-breathing-box") === "true";
    var breathingBoxAddon = document.querySelector(".breathing_box_body");
    if (breathingBoxAddon) {
      breathingBoxAddon.style.display = hasBreathingBoxValue ? "flex" : "none";
    }
  }

  function plushSyncBreedComboboxSearchFromSelect(select) {
    var root = select && select.closest("[data-breed-combobox]");
    if (!root) return;
    var search = root.querySelector(".breed-combobox__search");
    if (!search) return;
    var opt = select.options[select.selectedIndex];
    if (opt && opt.value) {
      search.value = opt.text || opt.value;
    } else {
      search.value = "";
    }
  }

  function plushFilterBreedComboboxOptions(root, query) {
    if (!root) return;
    var ql = (query || "").toLowerCase().trim();
    root.querySelectorAll(".breed-combobox__option").forEach(function (li) {
      var t = (li.textContent || "").toLowerCase();
      li.hidden = ql !== "" && t.indexOf(ql) === -1;
    });
  }

  function plushSetBreedFromCombobox(select, value) {
    var found = false;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === value) {
        select.selectedIndex = i;
        found = true;
        break;
      }
    }
    if (found) {
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
    plushSyncBreedComboboxSearchFromSelect(select);
  }

  function plushCloseAllBreedComboboxLists() {
    document.querySelectorAll(".breed-combobox__list").forEach(function (ul) {
      ul.hidden = true;
      var combo = ul.closest("[data-breed-combobox]");
      var s = combo && combo.querySelector(".breed-combobox__search");
      if (s) s.setAttribute("aria-expanded", "false");
    });
  }

  function plushOpenBreedCombobox(root) {
    var list = root.querySelector(".breed-combobox__list");
    var search = root.querySelector(".breed-combobox__search");
    if (!list || !search) return;
    plushFilterBreedComboboxOptions(root, search.value);
    list.hidden = false;
    search.setAttribute("aria-expanded", "true");
  }

  function plushRefreshBreedComboboxList(select) {
    var root = select && select.closest("[data-breed-combobox]");
    if (!root) return;
    plushEnsureBreedComboboxDocListeners();
    var list = root.querySelector(".breed-combobox__list");
    if (!list) return;
    list.innerHTML = "";
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      if (!opt.value || opt.disabled) continue;
      var li = document.createElement("li");
      li.className = "breed-combobox__option";
      li.setAttribute("role", "option");
      li.setAttribute("data-value", opt.value);
      li.textContent = opt.text || opt.value;
      list.appendChild(li);
    }
    plushFilterBreedComboboxOptions(
      root,
      (root.querySelector(".breed-combobox__search") || {}).value || "",
    );
    plushSyncBreedComboboxSearchFromSelect(select);
  }

  var plushBreedComboboxDocListenersBound = false;
  function plushEnsureBreedComboboxDocListeners() {
    if (plushBreedComboboxDocListenersBound) return;
    plushBreedComboboxDocListenersBound = true;

    document.addEventListener("click", function (e) {
      var optLi = e.target.closest(".breed-combobox__option");
      if (optLi) {
        var root = optLi.closest("[data-breed-combobox]");
        var sel = root && root.querySelector("#breedSelect");
        var list = root && root.querySelector(".breed-combobox__list");
        var search = root && root.querySelector(".breed-combobox__search");
        var val = optLi.getAttribute("data-value");
        if (sel && val) {
          plushSetBreedFromCombobox(sel, val);
        }
        if (list) list.hidden = true;
        if (search) search.setAttribute("aria-expanded", "false");
        return;
      }

      var caret = e.target.closest(".breed-combobox__caret");
      if (caret) {
        var rootC = caret.closest("[data-breed-combobox]");
        if (rootC) {
          var listC = rootC.querySelector(".breed-combobox__list");
          if (listC && listC.hidden) {
            plushOpenBreedCombobox(rootC);
            var sc = rootC.querySelector(".breed-combobox__search");
            if (sc) sc.focus();
          } else {
            plushCloseAllBreedComboboxLists();
          }
        }
        return;
      }

      if (e.target.closest("[data-breed-combobox]")) return;
      plushCloseAllBreedComboboxLists();
    });

    document.addEventListener("focusin", function (e) {
      var search = e.target.closest(".breed-combobox__search");
      if (!search) return;
      var root = search.closest("[data-breed-combobox]");
      if (root) plushOpenBreedCombobox(root);
    });

    document.addEventListener("input", function (e) {
      if (!e.target.classList || !e.target.classList.contains("breed-combobox__search"))
        return;
      var root = e.target.closest("[data-breed-combobox]");
      plushFilterBreedComboboxOptions(root, e.target.value);
      var list = root && root.querySelector(".breed-combobox__list");
      if (list) {
        list.hidden = false;
        e.target.setAttribute("aria-expanded", "true");
      }
    });

    document.addEventListener("keydown", function (e) {
      if (!e.target.classList || !e.target.classList.contains("breed-combobox__search"))
        return;
      if (e.key === "Escape") {
        plushCloseAllBreedComboboxLists();
        e.target.blur();
      }
    });
  }

  function selectedPetType(event) {
    const step3 = document.querySelector(".step3");
    const step4 = document.querySelector(".step4");
    const step5 = document.querySelector(".step5");
    const step6 = document.querySelector(".step6");
    const plushFrameSection = document.querySelector(".plush-frame-options");
    if (step3) step3.classList.add("disabled");
    if (step4) step4.classList.add("disabled");
    if (step5) step5.classList.add("disabled");
    if (step6) step6.classList.add("disabled");

    document
      .querySelectorAll(".pet-image-container")
      .forEach((petImage) => petImage.classList.remove("active"));
    document
      .querySelectorAll(".pet-image")
      .forEach((petImage) => petImage.classList.remove("active"));
    var element = event.target;
    var container = element.closest(".pet-image-container");
    var petImageEl = element.closest(".pet-image");
    if (container) {
      container.classList.add("active");

      var image = container.querySelector(".pet-image");
      if (image) {
        image.classList.add("active");
      }
    }
    selectedPetTypeName =
      (container && container.getAttribute("data-value")) ||
      (petImageEl && petImageEl.getAttribute("data-value")) ||
      "";
    if (!selectedPetTypeName) {
      return;
    }
    fetch(
      omsPlushDetails[0].url +
      "breeds?specie=" +
      encodeURIComponent(selectedPetTypeName),
      {
        method: "GET",
        headers: omsHeader,
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        var select = document.getElementById("breedSelect");
        if (!select || !data || !data.breeds) return;
        select.innerHTML = "";
        var defaultOption = document.createElement("option");
        defaultOption.value = "";
        defaultOption.text = "Pug, Beagle, Great Dane, etc";
        defaultOption.disabled = true;
        defaultOption.selected = true;
        select.appendChild(defaultOption);
        data.breeds.forEach(function (breed) {
          var option = document.createElement("option");
          option.value = breed?.description;
          option.text = breed?.description;
          option.setAttribute("data-breathing-box", breed?.breathing_box);
          select.appendChild(option);
        });

        plushRefreshBreedComboboxList(select);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });

    var petTypeEl = document.getElementById("pet-type");
    if (petTypeEl) petTypeEl.value = selectedPetTypeName;
    plushRenderAgeOptions(selectedPetTypeName);
    const earSection = document.getElementById("earImagesContainer");
    if (productOptionDisplay) {
      updatePetImages(selectedPetTypeName);
    }
    if (earSection) {
      if (selectedPetTypeName !== "other") {
        handleEarImages(selectedPetTypeName);
        earSection.style.padding = "20px 4px 50px";
      } else {
        earSection.style.display = "none";
        earSection.style.padding = "0px";
      }
    }
  }
  window.selectedPetType = selectedPetType;

  // Age options are per species. A species that publishes an entry in
  // `pet_ages_by_specie` gets its own list; every other one keeps the shared
  // `pet_ages` exactly as before. The option label is always the entry's
  // `name`; the saved value is its `age` when it publishes one, which is how
  // dog groups three ranges behind a single "Adult" option. The cart property
  // name (`properties[_pet_age]`) does not change - only the value it carries.
  //
  // Mirrors renderAgeOptions() in assets/plush-clone-customizer.js.
  function plushAgeOptionsFor(species) {
    var petType = (C.customizer && C.customizer[1] && C.customizer[1].pet_type) || [];
    var step = petType[2] || {};
    var perSpecies = step.pet_ages_by_specie || {};
    // A per-species entry only wins when it is actually a list, so a malformed
    // one falls back to the shared list rather than emptying the dropdown.
    var own = species ? perSpecies[species] : null;
    if (Array.isArray(own)) return own;
    return Array.isArray(step.pet_ages) ? step.pet_ages : [];
  }

  function plushAgeOptionValue(entry) {
    if (!entry) return "";
    var age = entry.age == null ? "" : String(entry.age).trim();
    return age || String(entry.name == null ? "" : entry.name);
  }

  function plushRenderAgeOptions(species) {
    var select = document.getElementById("petAge");
    if (!select) return;
    var options = plushAgeOptionsFor(species);
    // No catalog, no rebuild: the Liquid-rendered default list stays as it is
    // rather than being replaced with an empty dropdown.
    if (!options.length) return;

    select.innerHTML = "";
    var placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.textContent = "Select Age";
    select.appendChild(placeholder);

    options.forEach(function (entry) {
      if (!entry || !entry.name) return;
      var option = document.createElement("option");
      option.value = plushAgeOptionValue(entry);
      option.textContent = String(entry.name);
      select.appendChild(option);
    });

    // Species carry different value sets, so a pick made before the switch
    // cannot survive it.
    select.value = "";
  }

  /* Reflect a stored/preselected species in the Step 1 selector UI (highlight the
     matching circle) without re-fetching breeds. */
  function plushMarkSpeciesSelectedInUI(specieName) {
    if (!specieName) return;
    var containers = document.querySelectorAll(".step_SpecieType .pet-image-container");
    containers.forEach(function (container) {
      var isMatch = container.getAttribute("data-value") === specieName;
      container.classList.toggle("active", isMatch);
      var img = container.querySelector(".pet-image");
      if (img) img.classList.toggle("active", isMatch);
    });
  }

  /* Fully select a species by its stored value (highlight circle + load its breeds),
     used when Step 1 stays visible for a preselected species. */
  function plushSelectSpeciesFromValue(specieName) {
    if (!specieName) return;
    var containers = document.querySelectorAll(".step_SpecieType .pet-image-container");
    var target = Array.prototype.find.call(containers, function (c) {
      return c.getAttribute("data-value") === specieName;
    });
    if (!target) return;
    selectedPetType({ target: target });
  }

  function scrollToElement(event) {
    event.preventDefault();
    var element = document.getElementById("get-to-know");

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  function getStep3UploadCard() {
    return document.querySelector(".step-3.step3-upload-card");
  }

  function getStep3ImageRootForDelete() {
    const card = getStep3UploadCard();
    const previewEl = document.getElementById("preview");
    if (card && previewEl && previewEl.classList.contains("step3-preview")) {
      return card;
    }
    return previewEl;
  }

  function orderedStep3PreviewContainers() {
    const card = getStep3UploadCard();
    if (!card) return [];
    const out = [];
    const slots = Array.prototype.slice
      .call(card.querySelectorAll(".step3-upload-slot[data-step3-slot]"))
      .sort(function (a, b) {
        return (
          Number(a.getAttribute("data-step3-slot")) -
          Number(b.getAttribute("data-step3-slot"))
        );
      });
    slots.forEach(function (slot) {
      const host = slot.querySelector(".step3-slot-preview-host");
      if (!host) return;
      const c = host.querySelector(".image-container");
      if (c) out.push(c);
    });
    const optHost = card.querySelector(".step3-optional-previews-host");
    if (optHost) {
      optHost
        .querySelectorAll(
          ":scope > .step3-slot-upload-bundle > .image-container",
        )
        .forEach(function (c) {
          out.push(c);
        });
      optHost
        .querySelectorAll(":scope > .image-container")
        .forEach(function (c) {
          if (!c.closest(".step3-slot-upload-bundle")) {
            out.push(c);
          }
        });
    }
    return out;
  }

  function countCustomizerStep3ImageContainers() {
    const card = getStep3UploadCard();
    const previewEl = document.getElementById("preview");
    if (card && previewEl && previewEl.classList.contains("step3-preview")) {
      return card.querySelectorAll(".image-container").length;
    }
    if (previewEl) {
      return previewEl.querySelectorAll(":scope > .image-container").length;
    }
    return 0;
  }

  function countImagesForCapacity(container) {
    if (
      container &&
      container.classList &&
      container.classList.contains("step3-upload-card")
    ) {
      return container.querySelectorAll(".image-container").length;
    }
    if (container && container.id === "preview") {
      return container.querySelectorAll(":scope > .image-container").length;
    }
    return 0;
  }

  function updateStep3CtaState() {
    const step3El = document.querySelector(".step3");
    if (!step3El) return;
    const btn = step3El.querySelector(".step3-primary-cta");
    if (!btn) return;
    const minReq = Math.max(
      1,
      parseInt(String(C.customizer[2].pet_detail[0].require_images), 10) || 3,
    );
    const previewEl = document.getElementById("preview");
    let n = 0;
    if (
      previewEl &&
      previewEl.classList.contains("step3-preview") &&
      getStep3UploadCard()
    ) {
      n = countCustomizerStep3ImageContainers();
    } else if (previewEl) {
      n = previewEl.querySelectorAll("img").length;
    }
    btn.disabled = n < minReq;
  }

  /** Map preview card → properties[image_N_description] (uses #image-links after upload, else DOM order). */
  function resolveImagePropertyKey(DescBox_Container) {
    let myContainer = DescBox_Container.closest(".image-container");
    if (
      !myContainer &&
      DescBox_Container.previousElementSibling &&
      DescBox_Container.previousElementSibling.classList &&
      DescBox_Container.previousElementSibling.classList.contains(
        "image-container",
      )
    ) {
      myContainer = DescBox_Container.previousElementSibling;
    }
    const previewEl = document.getElementById("preview");
    if (!myContainer || !previewEl) return null;
    const img = myContainer.querySelector("img");
    if (!img) return null;
    const imgId = img.dataset.originalid;
    const liveIndex = document.querySelectorAll("#preview #image-links input");
    for (let i = 0; i < liveIndex.length; i++) {
      if (liveIndex[i].dataset.id == imgId) {
        return liveIndex[i].dataset.originalindex;
      }
    }
    const step3Card = getStep3UploadCard();
    let containers;
    if (step3Card && previewEl.classList.contains("step3-preview")) {
      containers = orderedStep3PreviewContainers().concat(
        Array.prototype.slice.call(
          previewEl.querySelectorAll(":scope > .image-container"),
        ),
      );
    } else {
      containers = Array.prototype.slice.call(
        previewEl.querySelectorAll(":scope > .image-container"),
      );
    }
    const idx = containers.indexOf(myContainer);
    return idx >= 0 ? "image_" + (idx + 1) : null;
  }

  /** Per-image notes (Step 3): legacy DescriptionBox + overlay note/edit buttons. */
  function togglePerImageDescription(DescBox_Container, boldText) {
    const container = DescBox_Container;
    let textarea = container.querySelector("textarea");
    const actualIndex = resolveImagePropertyKey(DescBox_Container);
    if (!actualIndex) return;

    if (textarea) {
      textarea.classList.remove("show");
      if (boldText) boldText.textContent = "Add Image Description";
      var taClose = textarea;
      var finishClose = (function () {
        var done = false;
        return function () {
          if (done || !taClose || !taClose.parentNode) return;
          done = true;
          var v = taClose.value;
          container.dataset.step3DescDraft = v && String(v).trim() ? v : "";
          taClose.remove();
        };
      })();
      /* Step 3 card: no closing transition on textarea — transitionend never fires; remove immediately */
      if (container.closest(".step-3.step3-upload-card")) {
        window.setTimeout(finishClose, 0);
      } else {
        taClose.addEventListener("transitionend", finishClose, { once: true });
        window.setTimeout(finishClose, 400);
      }
    } else {
      textarea = document.createElement("textarea");
      textarea.name = "properties[" + actualIndex + "_description]";
      textarea.placeholder =
        "Provide unique details for our artist to pay attention to in the photo above";
      textarea.className = "image-description";
      if (typeof container.dataset.step3DescDraft === "string") {
        textarea.value = container.dataset.step3DescDraft;
      }
      textarea.addEventListener("input", function () {
        container.dataset.step3DescDraft = textarea.value;
      });
      container.appendChild(textarea);
      textarea.focus();
      requestAnimationFrame(function () {
        textarea.classList.add("show");
      });
      if (boldText) boldText.textContent = "Remove Image Description";
    }
  }

  let imageCounter = 0;
  async function dragNdrop(event) {
    let preview = document.getElementById("preview");
    let uploadLaterWrapper = document.querySelector(".uplaodLaterWrapper");

    const step3UploadCard = document.querySelector(".step-3.step3-upload-card");
    const isStep3SlotMode =
      preview &&
      preview.classList &&
      preview.classList.contains("step3-preview") &&
      step3UploadCard &&
      step3UploadCard.contains(event.target);

    let existingMainImageCount = 0;
    if (
      preview &&
      preview.classList.contains("step3-preview") &&
      step3UploadCard
    ) {
      existingMainImageCount =
        step3UploadCard.querySelectorAll(".image-container").length;
    } else if (preview) {
      existingMainImageCount = preview.querySelectorAll(
        ":scope > .image-container",
      ).length;
    }

    var files = event.target.files;
    const fileInputEl = event.target;
    if (!files || files.length === 0) {
      return;
    }
    let imageName;
    if (uploadLaterWrapper && files.length >= 1) {
      uploadLaterWrapper.style.display = "none";
    }

    for (let j = 0; j < files.length; j++) {
      if (plushStep3RejectFileSize(files[j], fileInputEl)) {
        return;
      }
    }

    if (existingMainImageCount + files.length > maxImages) {
      alert(
        "Maximum allowed images is " +
        maxImages +
        ". You are trying to upload " +
        (existingMainImageCount + files.length) +
        " images.",
      );
      return;
    }

    for (let i = 0; i < files.length; i++) {
      imageCounter++;
      const fileInput = fileInputEl;
      let appendHost = preview;
      let reqSlotForFill = null;
      if (isStep3SlotMode && step3UploadCard) {
        const reqSlot = fileInput.closest(".step3-upload-slot");
        const optArea = fileInput.closest(".step3-upload-optional");
        if (reqSlot) {
          appendHost = reqSlot.querySelector(".step3-slot-preview-host");
          reqSlotForFill = reqSlot;
          if (appendHost) {
            const existing = appendHost.querySelector(".image-container");
            if (existing) {
              const exImg = existing.querySelector("img");
              if (exImg && exImg.dataset.originalid) {
                deleteImage(
                  getStep3ImageRootForDelete(),
                  exImg.dataset.originalid,
                );
              }
            }
          }
        } else if (optArea) {
          appendHost =
            optArea.querySelector(".step3-optional-previews-host") || preview;
        }
      }
      if (!appendHost) appendHost = preview;

      let imageContainer = document.createElement("div");

      const DescBox_Container = document.createElement("div");
      const DescBox = document.createElement("div");
      let previewImg = document.createElement("img");
      const ext = files[i].name.split(".").pop().toLowerCase();

      if (!files[i].type.startsWith("image/")) {
        // fallback for windows : allow heic/heif if extension matches
        if (ext !== "heic" && ext !== "heif") {
          alert("Please select only image files.");
          return;
        }
      }

      if (
        files[i].type !== "image/jpg" &&
        files[i].type !== "image/png" &&
        files[i].type !== "image/bmp" &&
        files[i].type !== "image/jpeg" &&
        files[i].type !== "image/heic" &&
        files[i].type !== "image/heif"
      ) {
        // fallback for windows : allow heic/heif if extension matches
        if (ext !== "heic" && ext !== "heif") {
          alert(
            `This type of image is not allowed. Please use only jpg, png, bmp , heic or heif.`,
          );
          return;
        }
      }

      if (plushStep3RejectFileSize(files[i], fileInput)) {
        return;
      }

      /* Convert HEIC/HEIF to JPEG in browser so backend/Shopify never see HEIC (fixes iPhone uploads) */
      let fileToUpload = files[i];
      const isHeic =
        ext === "heic" ||
        ext === "heif" ||
        files[i].type === "image/heic" ||
        files[i].type === "image/heif";
      if (typeof heic2any !== "undefined" && isHeic) {
        var heicBlob = files[i];
        if (!files[i].type || files[i].type === "application/octet-stream") {
          heicBlob = new Blob([files[i]], {
            type: ext === "heif" ? "image/heif" : "image/heic",
          });
        }
        var converted = null;
        try {
          converted = await heic2any({
            blob: heicBlob,
            toType: "image/jpeg",
            quality: 0.92,
            multiple: false,
          });
        } catch (e1) {
          try {
            converted = await heic2any({
              blob: heicBlob,
              toType: "image/png",
              multiple: false,
            });
          } catch (e2) {
            console.error("HEIC conversion failed:", e1, e2);
            alert(
              "This HEIC image could not be converted in your browser. Try: (1) Settings > Camera > Formats > Most Compatible, or (2) upload a JPEG/PNG instead.",
            );
            return;
          }
        }
        var blob = Array.isArray(converted) ? converted[0] : converted;
        var outType = blob.type || "image/jpeg";
        var outExt = outType.indexOf("png") >= 0 ? ".png" : ".jpg";
        fileToUpload = new File(
          [blob],
          files[i].name.replace(/\.(heic|heif)$/i, outExt),
          { type: outType, lastModified: Date.now() },
        );
      }

      if (plushStep3RejectFileSize(fileToUpload, fileInput)) {
        return;
      }

      previewImg.setAttribute(
        "src",
        "https://cdn.shopify.com/s/files/1/0537/2585/5916/files/Spinner-1s-200px.gif",
      );
      previewImg.setAttribute("tabindex", "0");
      previewImg.addEventListener("keydown", handleImagesDiv);
      previewImg.alt = `Questionimage_${imageCounter}`;
      previewImg.setAttribute("data-originalId", `image_${imageCounter}`);

      preview.appendChild(previewImg);

      DescBox_Container.classList.add("DescriptionBox_Container");
      DescBox.classList.add("DescriptionBox");
      DescBox.setAttribute("tabindex", "0");
      DescBox.addEventListener("keydown", handle_DescriptionBox_textarea);
      DescBox.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M21.7891 1.47978L22.3791 2.06978C23.1921 2.88378 23.0691 4.32678 22.1021 5.29278L9.93505 17.4598L5.99305 18.9018C5.49805 19.0838 5.01605 18.8478 4.91805 18.3768C4.88504 18.2059 4.90063 18.0292 4.96305 17.8668L6.43305 13.8908L18.5661 1.75678C19.5331 0.790781 20.9761 0.665781 21.7891 1.47978ZM9.40405 2.68978C9.53537 2.68978 9.66541 2.71565 9.78674 2.7659C9.90806 2.81616 10.0183 2.88982 10.1112 2.98267C10.204 3.07553 10.2777 3.18577 10.3279 3.3071C10.3782 3.42842 10.4041 3.55846 10.4041 3.68978C10.4041 3.8211 10.3782 3.95114 10.3279 4.07246C10.2777 4.19379 10.204 4.30403 10.1112 4.39689C10.0183 4.48975 9.90806 4.56341 9.78674 4.61366C9.66541 4.66392 9.53537 4.68978 9.40405 4.68978H5.40405C4.87362 4.68978 4.36491 4.90049 3.98984 5.27557C3.61477 5.65064 3.40405 6.15935 3.40405 6.68978V18.6898C3.40405 19.2202 3.61477 19.7289 3.98984 20.104C4.36491 20.4791 4.87362 20.6898 5.40405 20.6898H17.4041C17.9345 20.6898 18.4432 20.4791 18.8183 20.104C19.1933 19.7289 19.4041 19.2202 19.4041 18.6898V14.6898C19.4041 14.4246 19.5094 14.1702 19.6969 13.9827C19.8845 13.7951 20.1388 13.6898 20.4041 13.6898C20.6693 13.6898 20.9236 13.7951 21.1112 13.9827C21.2987 14.1702 21.4041 14.4246 21.4041 14.6898V18.6898C21.4041 19.7506 20.9826 20.7681 20.2325 21.5182C19.4823 22.2684 18.4649 22.6898 17.4041 22.6898H5.40405C4.34319 22.6898 3.32577 22.2684 2.57563 21.5182C1.82548 20.7681 1.40405 19.7506 1.40405 18.6898V6.68978C1.40405 5.62892 1.82548 4.6115 2.57563 3.86135C3.32577 3.11121 4.34319 2.68978 5.40405 2.68978H9.40405Z" fill="#5461C8"/>
      </svg>
      `;

      const boldText = document.createElement("strong");
      boldText.textContent = "Add Image Description";

      const optionalText = document.createElement("span");
      optionalText.textContent = " (Optional)";

      DescBox.appendChild(boldText);
      DescBox.appendChild(optionalText);
      DescBox_Container.appendChild(DescBox);

      DescBox.addEventListener("click", function () {
        togglePerImageDescription(DescBox_Container, boldText);
      });

      let progressWrapper = document.createElement("div");
      progressWrapper.classList.add("progress-wrapper");

      progressWrapper.innerHTML = `
        <div class="progress-status">Upload Complete</div>
        <div class="progress-percentage">0%</div>
        <svg class="progress-circle" width="40" height="40">
        <circle class="progress-background" cx="20" cy="20" r="18"></circle>
        <circle class="progress_Bar" cx="20" cy="20" r="18"></circle>
        </svg>
      `;
      let progressCircle = progressWrapper.querySelector(".progress-circle");
      const progressStatus = progressWrapper.querySelector(".progress-status");
      const percentage = progressWrapper.querySelector(".progress-percentage");

      try {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", `${omsPlushDetails[0].url}image_uploader/print_image_oss`);
        xhr.setRequestHeader("api-token", omsPlushDetails[0].api_token);

        xhr.upload.addEventListener("progress", function (e) {
          if (e.lengthComputable) {
            const percent = Math.round((e.loaded / e.total) * 100);
            updateProgress(progressWrapper, percent);
          }
        });

        xhr.onload = function () {
          if (xhr.status === 200 || xhr.status === 201) {
            const data = JSON.parse(xhr.responseText);

            previewImg.src = data.imageUrl;

            const parts = data.imageUrl.split("/");
            imageName = parts[parts?.length - 1];
            progressCircle.style.display = "none";
            percentage.style.display = "none";
            progressStatus.style.display = "none";
            progressWrapper.style.display = "none";

            const previewElement = document.getElementById("preview");

            handleImages();
            updateStep3CtaState();
          } else {
            console.log(`Upload failed: ${xhr.status}`);
            progressStatus.innerHTML = "Upload Failed";
            progressCircle.style.display = "none";
            percentage.style.display = "none";
            progressStatus.style.display = "block";
          }
        };

        xhr.onerror = function () {
          console.log("Upload failed.");
          progressStatus.innerHTML = "Upload Failed";
          progressCircle.style.display = "none";
          percentage.style.display = "none";
          progressStatus.style.display = "block";
        };

        const formData = new FormData();
        formData.append("image", fileToUpload);
        xhr.send(formData);
      } catch (error) {
        console.log("Error:", error);
      }

      var deleteButton = document.createElement("button");
      deleteButton.type = "button";
      deleteButton.classList.add("delete-button");
      deleteButton.setAttribute("aria-label", "Remove photo");
      deleteButton.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<rect x="5" y="5" width="14" height="14" rx="3" fill="#1C1B1F"/>' +
        '<line x1="9.25" y1="9.25" x2="14.75" y2="14.75" stroke="#FFFFFF" stroke-width="1.75" stroke-linecap="round"/>' +
        '<line x1="14.75" y1="9.25" x2="9.25" y2="14.75" stroke="#FFFFFF" stroke-width="1.75" stroke-linecap="round"/>' +
        "</svg>";
      deleteButton.addEventListener("click", function () {
        const img = this.closest(".step3-thumb-wrap")
          ? this.closest(".step3-thumb-wrap").querySelector("img")
          : this.parentElement.querySelector("img");
        if (!img) return;
        const deletedImageId = img.dataset.originalid;
        const mainDeleteEvent = deleteImage(
          getStep3ImageRootForDelete(),
          deletedImageId,
        );

        if (!mainDeleteEvent) {
          // this will run  if deletion is blocked
          return;
        }
        updateStep3CtaState();
        let totalImagesUploaded = countCustomizerStep3ImageContainers();

        if (uploadLaterWrapper && totalImagesUploaded == 0) {
          uploadLaterWrapper.style.display = "block";
        }
      });

      imageContainer.classList.add("image-container");

      const isStep3Card =
        preview &&
        preview.classList &&
        preview.classList.contains("step3-preview");
      if (isStep3Card) {
        imageContainer.classList.add("step3-preview-item");
        DescBox.classList.add("step3-description-trigger--sr");

        const thumbWrap = document.createElement("div");
        thumbWrap.className = "step3-thumb-wrap";

        const actions = document.createElement("div");
        actions.className = "step3-thumb-actions";

        function step3ThumbBtn(classExtra, ariaLabel, svgMarkup) {
          const b = document.createElement("button");
          b.type = "button";
          b.className = "step3-thumb-btn " + classExtra;
          b.setAttribute("aria-label", ariaLabel);
          b.innerHTML = svgMarkup;
          return b;
        }

        const svgNotes =
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<rect x="4.5" y="3" width="15" height="18" rx="3" fill="#1C1B1F"/>' +
          '<line x1="7.5" y1="8" x2="16.5" y2="8" stroke="#FFFFFF" stroke-width="1.75" stroke-linecap="round"/>' +
          '<line x1="7.5" y1="11" x2="16.5" y2="11" stroke="#FFFFFF" stroke-width="1.75" stroke-linecap="round"/>' +
          '<line x1="7.5" y1="14" x2="12" y2="14" stroke="#FFFFFF" stroke-width="1.75" stroke-linecap="round"/>' +
          "</svg>";
        const svgPencil =
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<rect x="2.5" y="18.75" width="19" height="2.75" rx="1.375" fill="#1C1B1F"/>' +
          '<path fill="#1C1B1F" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41L18.37 3.29a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>' +
          '<rect x="14.85" y="4.15" width="2.5" height="2.5" rx="0.5" fill="#FFFFFF" transform="rotate(45 16.1 5.4)"/>' +
          "</svg>";

        const btnNotes = step3ThumbBtn(
          "step3-thumb-btn--notes",
          "Notes for this photo",
          svgNotes,
        );
        const btnEdit = step3ThumbBtn(
          "step3-thumb-btn--edit",
          "Edit note for this photo",
          svgPencil,
        );

        btnNotes.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          togglePerImageDescription(DescBox_Container, boldText);
        });
        btnEdit.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var wasOpen = !!DescBox_Container.querySelector(
            "textarea.image-description",
          );
          togglePerImageDescription(DescBox_Container, boldText);
          if (!wasOpen) {
            var ta = DescBox_Container.querySelector(
              "textarea.image-description",
            );
            if (ta) ta.focus();
          }
        });

        actions.appendChild(btnNotes);
        actions.appendChild(btnEdit);

        thumbWrap.appendChild(progressWrapper);
        thumbWrap.appendChild(deleteButton);
        thumbWrap.appendChild(previewImg);
        thumbWrap.appendChild(actions);
        imageContainer.appendChild(thumbWrap);
      } else {
        imageContainer.appendChild(progressWrapper);
        imageContainer.appendChild(deleteButton);
        imageContainer.appendChild(previewImg);
        imageContainer.appendChild(DescBox_Container);
      }

      if (isStep3Card) {
        const bundle = document.createElement("div");
        bundle.className = "step3-slot-upload-bundle";
        if (
          appendHost &&
          appendHost.classList &&
          appendHost.classList.contains("step3-optional-previews-host")
        ) {
          bundle.classList.add("step3-slot-upload-bundle--optional-extras");
        }
        bundle.appendChild(imageContainer);
        bundle.appendChild(DescBox_Container);
        appendHost.appendChild(bundle);
      } else {
        appendHost.appendChild(imageContainer);
      }
      if (reqSlotForFill) {
        reqSlotForFill.classList.add("step3-slot--filled");
      }
    }

    const uploadedCount = countCustomizerStep3ImageContainers();
    if (uploadedCount >= maxImages) {
      applyStep3UploadCapacityState(true);
      requestAnimationFrame(function () {
        alert("Maximum " + maxImages + " images are uploaded.");
      });
    } else {
      applyStep3UploadCapacityState(false);
    }
    disableRemainingSections();
  }

  function updateProgress(progressWrapper, percent) {
    const progressBar = progressWrapper.querySelector(".progress_Bar");
    const percentageText = progressWrapper.querySelector(
      ".progress-percentage",
    );
    const progressStatus = progressWrapper.querySelector(".progress-status");

    const radius = 18;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percent / 100) * circumference;

    progressBar.style.strokeDashoffset = offset;
    percentageText.textContent = `${percent}%`;

    if (percent >= 100) {
      progressStatus.textContent = "Upload Complete";
    }
  }

  function handleImages() {
    const previewElement = document.getElementById("preview");
    // Check if the element exists
    if (previewElement) {
      const step3Card = getStep3UploadCard();
      const useSlotOrder =
        step3Card &&
        previewElement.classList &&
        previewElement.classList.contains("step3-preview");
      let imageTagsArray;
      if (useSlotOrder) {
        const fromSlots = orderedStep3PreviewContainers()
          .map(function (c) {
            return c.querySelector("img");
          })
          .filter(Boolean);
        const fromPreviewRoot = Array.prototype.slice
          .call(previewElement.querySelectorAll(":scope > .image-container"))
          .map(function (c) {
            return c.querySelector("img");
          })
          .filter(Boolean);
        imageTagsArray = fromSlots.concat(fromPreviewRoot);
      } else {
        imageTagsArray = Array.from(previewElement.querySelectorAll("img"));
      }
      const imageLinksElement = document.getElementById("image-links");
      // imageLinksElement.style.display="none";
      if (imageLinksElement) {
        imageLinksElement.remove();
      }
      const divElement = document.createElement("div");

      // Set the id attribute to "image-lnks"
      divElement.setAttribute("id", "image-links");

      imageTagsArray.forEach((element, index) => {
        const hiddenInput = document.createElement("input");
        hiddenInput.setAttribute("type", "hidden");
        hiddenInput.setAttribute("class", "uploadedHiddenImages");
        hiddenInput.setAttribute(
          "name",
          "properties[image_" + (index + 1) + "]",
        );
        hiddenInput.setAttribute("data-id", element.dataset.originalid);
        hiddenInput.setAttribute("data-originalindex", "image_" + (index + 1));
        hiddenInput.setAttribute("value", element.src);
        divElement.appendChild(hiddenInput);
      });
      const imagePreview = document.getElementById("preview");
      imagePreview.appendChild(divElement);
    }
  }

  function deleteImage(container, imageId) {
    const targetElement = container.querySelector(
      `img[data-originalid="${imageId}"]`,
    );
    if (!targetElement) return false;

    const imageContainer = targetElement.closest(".image-container");
    if (imageContainer) {
      const slot = imageContainer.closest(".step3-upload-slot");
      const host = slot ? slot.querySelector(".step3-slot-preview-host") : null;
      const bundle = imageContainer.closest(".step3-slot-upload-bundle");
      if (bundle && bundle.parentNode) {
        bundle.remove();
      } else {
        imageContainer.remove();
      }
      if (slot && host && !host.querySelector(".image-container")) {
        slot.classList.remove("step3-slot--filled");
      }
    }

    if (countImagesForCapacity(container) < maxImages) {
      applyStep3UploadCapacityState(false);
    }
    return true;
  }

  function drag(e) {
    if (e && e.preventDefault) e.preventDefault();
  }

  function drop(e) {
    if (e && e.preventDefault) e.preventDefault();
  }

  function step3DragOver(e) {
    if (e && e.preventDefault) e.preventDefault();
  }

  function step3Drop(e) {
    if (e && e.preventDefault) e.preventDefault();
    var dt = e && e.dataTransfer;
    if (!dt || !dt.files || dt.files.length === 0) return;
    var root =
      e.currentTarget &&
      e.currentTarget.closest &&
      e.currentTarget.closest(".step3-upload-slot, .step3-upload-optional");
    var input = root && root.querySelector(".imageUploader");
    if (!input) return;

    var multi = input.hasAttribute("multiple");
    var picked = multi
      ? Array.prototype.slice.call(dt.files)
      : [dt.files[0]].filter(Boolean);
    for (var j = 0; j < picked.length; j++) {
      if (plushStep3RejectFileSize(picked[j], input)) return;
    }

    var transfer = new DataTransfer();
    for (var k = 0; k < picked.length; k++) {
      transfer.items.add(picked[k]);
    }
    input.files = transfer.files;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function showHideTwoPallets(checkbox) {
    var newElement = document.querySelectorAll(".color-container .second-half");
    const secondHalf = document.getElementsByClassName("second-half");
    if (checkbox.checked) {
      secondHalf.style.display = "block";
    }
    // Update colorItems after cloning
    const colorItems = document.querySelectorAll(".color");
    colorItems.forEach((item) => {
      item.onclick = selectColor; // Reassign onclick event
    });
  }

  // Update colorItems after cloning
  const colorItems = document.querySelectorAll(".color");
  colorItems.forEach((item) => {
    item.onclick = selectColor; // Reassign onclick event
  });

  function selectColor(event) {
    const selectedColor = event.currentTarget;

    // Check if the color is in the first half or the second half
    const firstHalf = document.getElementById("color_container").children[0];
    const secondHalf = document.getElementById("color_container").children[1];

    const isFirstHalf = firstHalf.contains(selectedColor);
    const isSecondHalf = secondHalf && secondHalf.contains(selectedColor);

    // If the color is already selected, remove the selection
    if (selectedColor.classList.contains("selected")) {
      selectedColor.classList.remove("selected");
      const tickIcon = selectedColor.querySelector(".material-icons");
      if (tickIcon) {
        selectedColor.removeChild(tickIcon);
      }
      return;
    }

    // If the color is from the first half, deselect all colors in the first half
    if (isFirstHalf) {
      firstHalf.querySelectorAll(".color.selected").forEach((item) => {
        item.classList.remove("selected");
        const tickIcon = item.querySelector(".material-icons");
        if (tickIcon) {
          item.removeChild(tickIcon);
        }
      });
    }

    // If the color is from the second half, deselect all colors in the second half
    if (isSecondHalf) {
      secondHalf.querySelectorAll(".color.selected").forEach((item) => {
        item.classList.remove("selected");
        const tickIcon = item.querySelector(".material-icons");
        if (tickIcon) {
          item.removeChild(tickIcon);
        }
      });
    }

    // Add selection to the clicked color
    selectedColor.classList.add("selected");
    const tickIcon = document.createElement("i");
    tickIcon.classList.add("material-icons");
    tickIcon.textContent = "done";
    selectedColor.appendChild(tickIcon);
  }

  var maxImages = 10;
  var preview = document.getElementById("preview");
  var uploadDiv = document.querySelectorAll(".uploadOuter");
  var capacityDiv = document.querySelector(".image-capacity-full-container");

  var sizeData = getCuddleclonesOptionsValue();

  if (capacityDiv) capacityDiv.style.display = "none";

  /**
   * At max images: hide only upload controls, not .uploadOuter wrappers (those contain previews).
   */
  function applyStep3UploadCapacityState(atCapacity) {
    const step3Card = getStep3UploadCard();
    if (step3Card) {
      step3Card.querySelectorAll(".uploadOuter").forEach(function (el) {
        el.style.removeProperty("display");
        const optRow = el.querySelector(".step3-optional-upload-row");
        if (optRow) {
          optRow.style.display = atCapacity ? "none" : "";
        }
        el.querySelectorAll(".imageUploader").forEach(function (inp) {
          if (atCapacity) {
            inp.style.display = "none";
          } else {
            inp.style.removeProperty("display");
          }
        });
      });
      if (capacityDiv) {
        capacityDiv.style.display = atCapacity ? "flex" : "none";
      }
      return;
    }
    uploadDiv.forEach(function (uploader) {
      uploader.style.display = atCapacity ? "none" : "block";
    });
    if (capacityDiv) {
      capacityDiv.style.display = atCapacity ? "flex" : "none";
    }
  }

  function productHydrateAddonAndRushPrices() {
    var currencySymbol = "$";
    function ccFormatMoneyCents(cents) {
      var n = Number(cents);
      if (!Number.isFinite(n)) return "";
      try {
        if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
          var fmt =
            window.money_format ||
            (window.theme && window.theme.settings && window.theme.settings.moneyFormat);
          if (fmt) {
            return Shopify.formatMoney(n, fmt);
          }
        }
      } catch (e) { }
      return currencySymbol + (n / 100).toFixed(2);
    }
    function ccFindRushVariant(variants, rawValue, dataName) {
      if (!variants || !variants.length) return null;
      var vid = String(rawValue || "").trim();
      if (vid) {
        var gidMatch = vid.match(/ProductVariant\/(\d+)/i);
        if (gidMatch) vid = gidMatch[1];
        var byId = variants.find(function (v) {
          return String(v.id) === vid || String(v.id) === String(Number(vid));
        });
        if (byId) return byId;
      }
      var name = (dataName || "").trim().toLowerCase();
      if (name) {
        var exact = variants.find(function (v) {
          return (v.title || "").trim().toLowerCase() === name;
        });
        if (exact) return exact;
        return (
          variants.find(function (v) {
            return (v.title || "").toLowerCase().indexOf(name) !== -1;
          }) || null
        );
      }
      return null;
    }

    document.querySelectorAll(".final-product-card").forEach(function (card) {
      var handle = (card.getAttribute("data-product-handle") || "").trim();
      var productPrice = card.querySelector(".final-product-add-on-price");
      var comparePrice = card.querySelector(".final-product-add-on-strike");
      var fallbackPrice = card.getAttribute("data-fallback-price") || "";
      var fallbackStrike = card.getAttribute("data-fallback-strike") || "";
      if (!productPrice) return;
      function applyAddonFallbacks() {
        if (fallbackPrice) productPrice.textContent = fallbackPrice;
        if (comparePrice) comparePrice.textContent = fallbackStrike || "";
      }
      if (!handle) {
        if (!productPrice.textContent.trim()) applyAddonFallbacks();
        return;
      }
      fetch("/products/" + encodeURIComponent(handle) + ".js")
        .then(function (response) {
          if (!response.ok) {
            throw new Error("HTTP error! Status: " + response.status);
          }
          return response.json();
        })
        .then(function (data) {
          if (data && data.price != null) {
            productPrice.textContent = ccFormatMoneyCents(data.price);
          }
          if (comparePrice) {
            comparePrice.textContent =
              data.compare_at_price && data.compare_at_price > data.price
                ? ccFormatMoneyCents(data.compare_at_price)
                : "";
          }
        })
        .catch(function (error) {
          console.error("Add-on price fetch:", error);
          applyAddonFallbacks();
        });
    });

    /* Take a rush tier off step 6 for the rest of the day: hide its row, disable its radio and drop
       its option from the select the step validates and the cart reads. If it was already checked
       (hydration lands after a fast click), the selection is cleared so the customer must pick
       again rather than carry a tier we can't fulfil into the cart. */
    function ccHideSoldOutRushRow(row, radioInput) {
      row.hidden = true;
      radioInput.disabled = true;
      var rushSelect = document.querySelector(".rushSelect");
      var wasChecked = radioInput.checked;
      if (wasChecked) radioInput.checked = false;
      if (!rushSelect) return;
      for (var i = rushSelect.options.length - 1; i > 0; i--) {
        if (String(rushSelect.options[i].value) === String(radioInput.value)) rushSelect.remove(i);
      }
      if (wasChecked || String(rushSelect.value) === String(radioInput.value)) {
        rushSelect.selectedIndex = 0;
        rushSelect.dispatchEvent(new Event("change"));
      }
    }

    function applyRushRowFallbacks() {
      document.querySelectorAll(".main_content_rush_container").forEach(function (row) {
        var priceDisplay = row.querySelector(".rush_price_cont");
        var fb = row.getAttribute("data-fallback-rush-price");
        if (priceDisplay && fb) priceDisplay.textContent = fb;
      });
    }

    var rushRoot = document.querySelector(".rush_container_main");
    var rushHandle = rushRoot && (rushRoot.getAttribute("data-rush-handle") || "").trim();
    if (!rushHandle) {
      document.querySelectorAll(".main_content_rush_container").forEach(function (row) {
        var priceDisplay = row.querySelector(".rush_price_cont");
        var fb = row.getAttribute("data-fallback-rush-price");
        if (priceDisplay && fb && !priceDisplay.textContent.trim()) {
          priceDisplay.textContent = fb;
        }
      });
    } else {
      /* Cache-buster: this response decides whether the daily-capped tier is still offerable, so a
         CDN-cached copy could sell the last of the day's spots twice. */
      fetch("/products/" + encodeURIComponent(rushHandle) + ".js?_=" + Date.now())
        .then(function (response) {
          if (!response.ok) {
            throw new Error("HTTP error! Status: " + response.status);
          }
          return response.json();
        })
        .then(function (data) {
          var rows = document.querySelectorAll(".main_content_rush_container");
          var variants = (data && data.variants) || [];
          rows.forEach(function (row, idx) {
            var radioInput = row.querySelector('input[name="rushCreation"]');
            var priceDisplay = row.querySelector(".rush_price_cont");
            if (!radioInput || !priceDisplay) return;
            var matchingVariant = ccFindRushVariant(
              variants,
              radioInput.value,
              radioInput.getAttribute("data-name"),
            );
            /* Availability is only acted on for a variant matched by id or name. The positional
               fallback below is a price-display convenience and can pair a row with the wrong
               variant, which must never hide a tier the customer can still buy. */
            var matchedVariant = matchingVariant;
            if (!matchingVariant && variants[idx]) {
              matchingVariant = variants[idx];
            }
            if (matchingVariant && matchingVariant.price != null) {
              priceDisplay.textContent = ccFormatMoneyCents(matchingVariant.price);
            } else {
              var fb = row.getAttribute("data-fallback-rush-price");
              if (fb && !priceDisplay.textContent.trim()) priceDisplay.textContent = fb;
            }
            /* Capacity-capped tier sold out for the day (Next Day Production is capped via Shopify
               inventory and reset nightly). Keyed off the variant's own availability, not its
               label, so renaming the tier or capping another one needs no deploy. Untracked tiers
               always report available: true, so this can never hide them. */
            if (matchedVariant && matchedVariant.available === false) {
              ccHideSoldOutRushRow(row, radioInput);
            }
          });
        })
        .catch(function (error) {
          console.error("Rush price fetch:", error);
          applyRushRowFallbacks();
        });
    }
  }

  function updatePetImages(selectedPetTypeName) {
    var earImages = document.getElementById("earImagesContainer");
    if (earImages) {
      earImages.remove();
    }

    Array.from(container.children).forEach(function (el) {
      if (el.classList && el.classList.contains("section-container")) {
        el.remove();
      }
    });

    var productOptions = C.customizer[4].product_options;
    var earPlaced = false;

    // Iterate over each product option
    productOptions.forEach(function (option) {
      // Check if the selected pet type exists in the option
      if (selectedPetTypeName in option) {
        var petData = option[selectedPetTypeName];
        if (checkDisplayTrue(petData)) {
          if (Object.keys(petData).length > 0) {
            orderPetOptionPositions(petData).forEach(function (position) {
              generateSection(
                position,
                petData[`${position}`].images_and_positions,
              );
            });

            if (earImages) {
              var mouthRow = container.querySelector(".productPositions.mouth");
              var mouthSection =
                mouthRow && mouthRow.closest(".section-container");
              if (mouthSection) {
                mouthSection.after(earImages);
              } else {
                container.appendChild(earImages);
              }
              earPlaced = true;
              if (selectedPetTypeName === "dog") {
                earImages.style.display = "flex";
              } else {
                earImages.style.display = "none";
                earImages.style.padding = "0px";
              }
            }

            if (rushSection) {
              finalStepButton.innerHTML = "Next Step";
            } else {
              finalStepButton.innerHTML =
                'Final Step <span class="material-icons-outlined">arrow_forward</span>';
            }
          }
        }
      }
    });

    if (earImages && !earPlaced && container.parentNode) {
      container.parentNode.insertBefore(earImages, container.nextSibling);
    }

    productHydrateAddonAndRushPrices();
  }

  function validatePlushCloneOptions(event) {
    event.preventDefault();

    const petInfo = document.querySelector("#pet-info");
    const leftEyeColorInput = document.getElementById("left-eye-color");
    const rightEyeColorInput = document.getElementById("right-eye-color");
    const leftEyeColor = leftEyeColorInput.value.trim();
    const rightEyeColor = rightEyeColorInput.value.trim();

    if (!leftEyeColor || !rightEyeColor) {
      alert("Please select eye colors for both eyes.");
      petInfo.scrollIntoView({ behavior: "smooth" });
      const isProgressBarVisible =
        progressBarDisplay && progressBarDisplay.style.display === "block";
      const remValue = 15;
      const rootFontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize,
      );
      const offset = isProgressBarVisible ? remValue * rootFontSize : 0;
      const containerTop =
        petInfo.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: containerTop - offset,
        behavior: "smooth",
      });
      return;
    }

    const productOptions = C.customizer[4].product_options;
    if (
      selectedPetTypeName &&
      isPetTypeAvailable(selectedPetTypeName, productOptions)
    ) {
      const selectedPetOptions = productOptions.find(
        (opt) => opt[selectedPetTypeName],
      )[selectedPetTypeName];

      let bodyPositionError = false;

      Object.keys(selectedPetOptions).forEach((position) => {
        if (bodyPositionError) return;
        const detail = selectedPetOptions[position];
        if (detail.display && detail.images_and_positions.length) {
          const positionDiv = document.querySelector(
            `.${position.toLowerCase()}`,
          );
          if (!positionDiv) return;
          const bodyInputs = positionDiv.querySelectorAll("input");
          const selected = Array.from(bodyInputs).some(
            (input) => input.checked,
          );
          if (!selected) {
            alert(
              position === "Size"
                ? `Please select ${position} for Slipper.`
                : `Please select positions for ${position}.`,
            );
            positionDiv.scrollIntoView({ behavior: "smooth" });
            bodyPositionError = true;
            const isProgressBarVisible =
              progressBarDisplay &&
              progressBarDisplay.style.display === "block";
            const remValue = 17;
            const rootFontSize = parseFloat(
              getComputedStyle(document.documentElement).fontSize,
            );
            const offset = isProgressBarVisible ? remValue * rootFontSize : 0;
            const containerTop =
              positionDiv.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: containerTop - offset,
              behavior: "smooth",
            });
            return;
          }
        }
      });

      if (bodyPositionError) return;
    }

    const earImagesContainer = document.querySelector("#earImagesContainer");
    const isEarVisible =
      earImagesContainer && earImagesContainer.style.display !== "none";
    const hasEarOptions =
      earImagesContainer && earImagesContainer.innerHTML.trim() !== "";
    if (isEarVisible && hasEarOptions) {
      const leftEarInputs = earImagesContainer.querySelectorAll(
        'input[name="properties[_pet_left_ear]"]',
      );
      const rightEarInputs = earImagesContainer.querySelectorAll(
        'input[name="properties[_pet_right_ear]"]',
      );
      const toggle = document.getElementById("different-ear-position");
      const isDifferent = toggle?.checked;

      const leftEarSelected = Array.from(leftEarInputs).some(
        (input) => input.checked,
      );
      const rightEarSelected = Array.from(rightEarInputs).some(
        (input) => input.checked,
      );

      let validEars = false;
      if (isDifferent) {
        validEars = leftEarSelected && rightEarSelected;
      } else {
        validEars = leftEarSelected;
      }

      if (!validEars) {
        alert(
          isDifferent
            ? "Please select ear positions for both left and right ears."
            : "Please select an ear position.",
        );
        earImagesContainer.scrollIntoView({ behavior: "smooth" });
        const isProgressBarVisible =
          progressBarDisplay && progressBarDisplay.style.display === "block";
        const remValue = 15;
        const rootFontSize = parseFloat(
          getComputedStyle(document.documentElement).fontSize,
        );
        const offset = isProgressBarVisible ? remValue * rootFontSize : 0;
        const containerTop =
          earImagesContainer.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: containerTop - offset,
          behavior: "smooth",
        });
        return;
      }
    }

    if (plushFrameSection) {
      const backgroundOptions =
        document.getElementsByClassName("background-image");
      const frameOptions = document.getElementsByClassName("frame-image");

      const isBackgroundSelected = Array.from(backgroundOptions).some(
        (opt) => opt.checked || opt.classList.contains("selected"),
      );
      const isFrameSelected = Array.from(frameOptions).some(
        (opt) => opt.checked || opt.classList.contains("selected"),
      );

      if (!isBackgroundSelected || !isFrameSelected) {
        plushFrameSection.scrollIntoView({ behavior: "smooth" });
        alert("Please select Plush Frame and Background");
        return;
      }
    }

    //Passed all checks → go to rush or step6
    if (rushSection) {
      rushSection.classList.remove("disabled");
      rushSection.scrollIntoView({ behavior: "smooth" });
    } else {
      step6.classList.remove("disabled");
      step6.scrollIntoView({ behavior: "smooth" });
    }
  }

  function decreaseQuantity(event) {
    event.preventDefault();
    var quantityInput = document.getElementById("final_quantity");
    var quantity = parseInt(quantityInput.value);
    if (quantity > 1) {
      quantity--;
      quantityInput.value = quantity;
    }
  }

  function increaseQuantity(event) {
    event.preventDefault();
    var quantityInput = document.getElementById("final_quantity");
    var quantity = parseInt(quantityInput.value);
    quantity++;
    quantityInput.value = quantity;
  }

  function selectRightEar(element) {
    // Remove 'selected' class from all ear images
    document.querySelectorAll(".ear-image").forEach(function (ear) {
      ear.classList.remove("selected");
    });

    // Add 'selected' class to the clicked ear image
    element.classList.add("selected");
  }

  function selectLeftEar(element) {
    // Remove 'selected' class from all ear images
    document.querySelectorAll(".ear-image").forEach(function (ear) {
      ear.classList.remove("selected");
    });

    // Add 'selected' class to the clicked ear image
    element.classList.add("selected");
  }

  const radioButtons = document.querySelectorAll('input[type="radio"]');

  // Add click event listener to each radio button
  radioButtons.forEach((button) => {
    button.addEventListener("click", function () {
      // Get the value of the selected radio button
      const selectedValue = this.value;

      // Set the value of the input field with the selected ear value
      const inputField = document.getElementById(this.name);
      if (inputField) {
        inputField.value = selectedValue;
      }
    });
  });

  function showHideSecondPalette(checkbox) {
    const oneHalf = document.getElementById("ColorPaletteOneHalf");
    const secondPalette = document.getElementById("second-palette");
    const colorPaletteTab = document.querySelector(".Colorpalette-Tab");
    if (checkbox.checked) {
      colorPaletteTab.style.display = "block";
      document.getElementById("right-eye-color").value = "";
    } else {
      secondPalette.style.display = "none";
      colorPaletteTab.style.display = "none";
      oneHalf.style.display = "flex";
      // Clear the right eye color input and reset its value
      var left_eye_color = document.getElementById("left-eye-color").value;
      var right_eye_color = document.getElementById("right-eye-color").value;
      if (left_eye_color && left_eye_color != right_eye_color) {
        document.getElementById("right-eye-color").value = left_eye_color;
      }
    }
  }

  function setEyeColor(checkbox, eyeSide, color) {
    const eyeCheckbox = document.getElementById("different-eye-color");

    let colorName = color.toLowerCase().replace(/\s/g, "_");
    // Set the color for the specified eye
    document.getElementById(`${eyeSide}-eye-color`).value = colorName;

    if (!eyeCheckbox.checked) {
      document.getElementById("right-eye-color").value = colorName;
      document.getElementById("left-eye-color").value = colorName;
    } else {
      // Set the color for the specified eye
      if (eyeSide === "right") {
        document.getElementById("right-eye-color").value = colorName;
      } else if (eyeSide === "left") {
        document.getElementById("left-eye-color").value = colorName;
      }
    }
  }
  const stepSpecieType = document.querySelector(".step_SpecieType");
  const step2 = document.querySelector(".step2");
  const step3 = document.querySelector(".step3");
  const step4 = document.querySelector(".step4");
  const step5 = document.querySelector(".step5");
  const step6 = document.querySelector(".step6");

  const plushFrameSection = document.querySelector(".plush-frame-options");
  const rushSection = document.querySelector(".rushContainer_Parent");
  const finalStepButton = document.getElementById("final-step-button");

  step2.classList.add("disabled");
  step3.classList.add("disabled");
  step4.classList.add("disabled");
  step5.classList.add("disabled");
  step6.classList.add("disabled");

  if (rushSection) {
    rushSection.classList.add("disabled");
  }

  const emailInput = step2.querySelector(".email");
  const nextButtonSpecieType = stepSpecieType.querySelector(
    ".nextStep-button-SpecieType",
  );
  const nextButtonStep2 = step2.querySelector(".nextStep-button");
  const nextButtonStep3 = step3.querySelector(".startSelectionButton");

  let nextButtonRushSection;
  if (rushSection) {
    nextButtonRushSection = rushSection.querySelector(".nextStep-button");
  }

  const errorMsg = document.querySelector(".error-msg");

  const petTypeInput = document.getElementById("pet-type");

  /* Runs after step refs exist — avoids TDZ if DOMContentLoaded fires synchronously; restores petTypeInput/step2 usage for cart return / pre-selected species. */
  document.addEventListener("DOMContentLoaded", function () {
    const c0 = C.customizer && C.customizer[0] ? C.customizer[0] : {};
    const rawType = c0.selected_pet_type;
    const rawBreed = c0.pet_breed;
    const typeStr =
      rawType == null || rawType === "" ? "" : String(rawType).trim();
    const breedStr =
      rawBreed == null || rawBreed === "" ? "" : String(rawBreed).trim();
    /**
     * Skip species + renumber STEP pills only when resuming (type + breed from cart),
     * or when metafield JSON sets an explicit flag. A default-only selected_pet_type
     * must not hide Step 1 or turn "STEP 2" into "STEP 1".
     */
    const resumeSpecies =
      c0.skip_species_step === true ||
      c0.resume_from_cart === true ||
      c0.resume_customizer === true ||
      (typeStr !== "" && breedStr !== "");
    const selectedPetTypeValue = typeStr;
    const selectedPetBreedValue = breedStr;
    const step1Header = document.getElementById("step_one_1");
    const horizontalLineSteps = document.getElementById("horizontal_line_pet");
    const petBreedSelect = document.getElementById("breedSelect");
    if (resumeSpecies && selectedPetTypeValue) {
      if (
        petTypeInput &&
        stepSpecieType &&
        step1Header &&
        horizontalLineSteps &&
        step2
      ) {
        petTypeInput.value = selectedPetTypeValue;
        selectedPetTypeName = selectedPetTypeValue;
        plushMarkSpeciesSelectedInUI(selectedPetTypeValue);
        stepSpecieType.style.display = "none";
        step1Header.style.display = "none";
        horizontalLineSteps.style.display = "none";
        step2.classList.remove("disabled");

        const stepCircles = document.querySelectorAll(
          ".customizer-step__circle",
        );
        stepCircles.forEach(function (circle) {
          const matchSteps = circle.textContent.trim().match(/^STEP\s+(\d+)$/i);
          if (matchSteps) {
            const numSteps = parseInt(matchSteps[1], 10);
            if (numSteps > 1) {
              circle.textContent = "STEP " + (numSteps - 1);
            }
          }
        });
        fetch(
          omsPlushDetails[0].url +
          "breeds?specie=" +
          encodeURIComponent(selectedPetTypeName),
          {
            method: "GET",
            headers: omsHeader,
          },
        )
          .then(function (response) {
            if (!response.ok) {
              throw new Error("HTTP error! Status: " + response.status);
            }
            return response.json();
          })
          .then(function (data) {
            var select = document.getElementById("breedSelect");
            if (!select || !data || !data.breeds) return;
            select.innerHTML = "";
            var defaultOption = document.createElement("option");
            defaultOption.value = "";
            defaultOption.text = "Pug, Beagle, Great Dane, etc";
            defaultOption.disabled = true;
            defaultOption.selected = true;
            select.appendChild(defaultOption);
            data.breeds.forEach(function (breed) {
              var option = document.createElement("option");
              option.value = breed && breed.description;
              option.text = breed && breed.description;
              option.setAttribute(
                "data-breathing-box",
                breed && breed.breathing_box,
              );
              select.appendChild(option);
            });
            plushRefreshBreedComboboxList(select);
            if (
              selectedPetTypeValue &&
              selectedPetBreedValue &&
              petBreedSelect
            ) {
              const targetBreed = selectedPetBreedValue.toLowerCase();
              const matchOpt = Array.from(petBreedSelect.options).find(
                function (opt) {
                  return (
                    (opt.value || "").trim().toLowerCase() === targetBreed ||
                    (opt.text || "").trim().toLowerCase() === targetBreed
                  );
                },
              );
              if (matchOpt) {
                petBreedSelect.value = matchOpt.value;
                petBreedSelect.dispatchEvent(new Event("change", { bubbles: true }));
                plushSyncBreedComboboxSearchFromSelect(petBreedSelect);
                plushApplyBreedSelectSideEffects(petBreedSelect);
              }
            }
          })
          .catch(function (error) {
            console.error("Fetch error:", error);
          });

        var earSectionPre = document.getElementById("earImagesContainer");
        if (productOptionDisplay) {
          updatePetImages(selectedPetTypeName);
        }
        if (earSectionPre) {
          if (selectedPetTypeName !== "other") {
            handleEarImages(selectedPetTypeName);
            earSectionPre.style.padding = "20px 4px 50px";
          } else {
            earSectionPre.style.display = "none";
            earSectionPre.style.padding = "0px";
          }
        }
      }
    } else if (selectedPetTypeValue && stepSpecieType) {
      /* Preselected species without a full cart resume: keep Step 1 visible but
         reflect the stored species in the UI (highlight circle + load its breeds). */
      plushSelectSpeciesFromValue(selectedPetTypeValue);
    }

    productHydrateAddonAndRushPrices();
    setTimeout(productHydrateAddonAndRushPrices, 300);
  });

  // Get the pet name input element
  const petNameInput = step2.querySelector(
    'input[name="properties[_pet_name]"]',
  );
  // Allowed: Unicode letters/numbers (incl. Chinese for China Ops titles),
  // space (internal consecutive spaces intentionally not collapsed), and - : @ # $ % & ^
  const PET_NAME_ALLOWED_CHARS_REGEX = /^[\p{L}\p{N} \-:@#$%&^]*$/u;
  const PET_NAME_ALLOWED_CHARS_MESSAGE =
    "Pet name can only contain letters, numbers, spaces, and - : @ # $ % & ^";
  const PET_NAME_MAX_LENGTH = 18;
  const PET_NAME_MAX_LENGTH_MESSAGE = `Pet name cannot exceed ${PET_NAME_MAX_LENGTH} characters.`;
  if (petNameInput) {
    petNameInput.addEventListener("input", () => {
      // Strip characters outside the allowed set (Unicode letters/numbers + specials)
      const sanitizedValue = petNameInput.value.replace(
        /[^\p{L}\p{N} \-:@#$%&^]/gu,
        "",
      );
      if (sanitizedValue !== petNameInput.value) {
        petNameInput.value = sanitizedValue;
      }

      // Check character length and show alert if exceeded
      if (petNameInput.value.length > PET_NAME_MAX_LENGTH) {
        alert(PET_NAME_MAX_LENGTH_MESSAGE);
        petNameInput.value = petNameInput.value.substring(0, PET_NAME_MAX_LENGTH); // Trim excess characters
      }
    });
    // Trim leading/trailing spaces on blur (not on every keystroke, so a
    // trailing space typed mid-name isn't stripped before the next word).
    petNameInput.addEventListener("blur", () => {
      const trimmed = petNameInput.value.trim();
      if (trimmed !== petNameInput.value) {
        petNameInput.value = trimmed;
      }
    });
  }
  // Get the breed select element
  const breedSelect = document.getElementById("breedSelect");
  if (breedSelect) {
    breedSelect.addEventListener("change", function () {
      plushApplyBreedSelectSideEffects(breedSelect);
    });
  }
  // Get the age select element
  const ageSelect = step2.querySelector('select[name="properties[_pet_age]"]');

  const mixedBreed = document.querySelector(".otherMixedInput");

  const emailRegex =
    /^[^\s@]+@(?!.*\.\.)(?!.*\.@)[^\s@.]+(\.[^\s@.]+)*\.[a-zA-Z]{2,}$/;

  nextButtonStep2.addEventListener("click", (event) => {
    // Trim leading/trailing spaces before validating/submitting so the
    // cart property never carries surrounding whitespace.
    if (petNameInput && petNameInput.value !== petNameInput.value.trim()) {
      petNameInput.value = petNameInput.value.trim();
    }

    const emailValue = document.querySelector(".email").value.trim();
    const specieValue = document.querySelector("#pet-type").value.trim();
    const petNameValue = document.querySelector(".petName").value.trim();
    const breedValue = document.querySelector("#breedSelect").value;
    const petAgeValue = document.querySelector("#petAge").value;
    const petAgeBlock = document.querySelector("#petAge");

    const isEmailValid = emailRegex.test(emailInput.value.trim());

    const klaviyouData = {
      email: emailValue,
      name: petNameValue,
      species: specieValue,
      breed: breedValue,
      pet_age: petAgeValue,
    };

    const klaviyoBody = JSON.stringify(klaviyouData);

    const sendDataToKlaviyo = fetch(
      `${omsPlushDetails[0].url}klaviyo_api/send_pet_detail_to_klaviyo`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "api-token": omsPlushDetails[0].api_token,
        },
        body: klaviyoBody,
      },
    )
      .then((response) => response.json())
      .then((data) => console.log("Success:"))
      .catch((error) => console.log("Error:", error));

    // Check if a pet details are entered

    if (petNameInput.value.trim() === "") {
      alert("Please enter pet name.");
      petNameInput.focus();
      event.preventDefault();
    } else if (!PET_NAME_ALLOWED_CHARS_REGEX.test(petNameInput.value.trim())) {
      alert(PET_NAME_ALLOWED_CHARS_MESSAGE);
      petNameInput.focus();
      event.preventDefault();
    } else if (petNameInput.value.trim().length > PET_NAME_MAX_LENGTH) {
      alert(PET_NAME_MAX_LENGTH_MESSAGE);
      petNameInput.focus();
      event.preventDefault();
    } else if (!isEmailValid) {
      alert("Enter a valid email first");
      emailInput.scrollIntoView({ behavior: "smooth" });
      emailInput.focus();
      event.preventDefault();
    } else if (ageSelect.value === "") {
      event.preventDefault();
      alert("Please select age of pet.");
      petAgeBlock.scrollIntoView({ behavior: "smooth" });
      // Adjust scroll for progress bar
      if (progressBarDisplay && progressBarDisplay.style.display === "block") {
        window.scrollBy({ top: -15.625 * 16, behavior: "smooth" }); // 15.625rem converted to pixels (1rem = 16px)
      }
    } else if (breedSelect.value === "") {
      alert("Please select any breed specie.");
      event.preventDefault();
      var breedComboRootP =
        breedSelect && breedSelect.closest("[data-breed-combobox]");
      (breedComboRootP || breedSelect).scrollIntoView({ behavior: "smooth" });
      // Adjust scroll for progress bar
      if (progressBarDisplay && progressBarDisplay.style.display === "block") {
        window.scrollBy({ top: -15.625 * 16, behavior: "smooth" }); // 15.625rem converted to pixels (1rem = 16px)
      }
      var breedSearchElP = document.getElementById("breedComboboxSearch");
      if (breedSearchElP) breedSearchElP.focus();
      else if (breedSelect) breedSelect.focus();
    } else if (
      selectedBreedValue === "Other/Mixed" &&
      mixedBreed.value.trim() === ""
    ) {
      alert("Please enter Other/Mixed breed name");
      mixedBreed.scrollIntoView({ behavior: "smooth" });
      mixedBreed.focus();
    } else {
      step3.classList.remove("disabled");
      step3.scrollIntoView({ behavior: "smooth" });
    }
  });

  nextButtonSpecieType.addEventListener("click", (event) => {
    const specieValue = document.querySelector("#pet-type").value.trim();
    const petTypeSelected = specieValue !== "";
    const petTypeDiv = document.querySelector(".pet-images");

    if (!petTypeSelected) {
      event.preventDefault();
      alert("Select valid pet type.");
      const isProgressBarVisible =
        progressBarDisplay && progressBarDisplay.style.display === "block";
      const remValue = 15.625;
      const rootFontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize,
      );
      const offset = remValue * rootFontSize;
      const elementPosition =
        petTypeDiv.getBoundingClientRect().top + window.pageYOffset;
      const scrollPosition = elementPosition - offset;

      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    } else {
      step2.classList.remove("disabled");
      step2.scrollIntoView({ behavior: "smooth" });
    }
  });

  const uploadContainer = document.getElementById("dragArea");

  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  const thanksMessage = document.querySelector(".thanks_message");

  const minimumImages = C.customizer[2].pet_detail[0].require_images;

  function goStep3Next(event) {
    if (event) event.preventDefault();
    const previewElement = document.getElementById("preview");
    const minImg = Math.max(1, parseInt(String(minimumImages), 10) || 3);
    let imageCount = 0;
    if (
      previewElement &&
      previewElement.classList.contains("step3-preview") &&
      getStep3UploadCard()
    ) {
      imageCount = countCustomizerStep3ImageContainers();
    } else if (previewElement) {
      imageCount = previewElement.querySelectorAll("img").length;
    }
    if (imageCount >= minImg) {
      step4.classList.remove("disabled");
      step4.scrollIntoView({ behavior: "smooth" });
      step5.classList.remove("disabled");
    } else {
      disableRemainingSections();
      alert("Please upload at least " + minImg + " images of your pet.");
    }
  }

  nextButtonStep3.addEventListener("click", goStep3Next);

  const step3SkipLink = step3.querySelector(".step3-skip-link");
  if (step3SkipLink) {
    step3SkipLink.addEventListener("click", goStep3Next);
  }

  updateStep3CtaState();

  function disableRemainingSections() {
    const step4 = document.querySelector(".step4");
    const step5 = document.querySelector(".step5");
    const step6 = document.querySelector(".step6");
    step4.classList.add("disabled");
    step5.classList.add("disabled");
    step6.classList.add("disabled");
  }

  function extractStringInsideBrackets(str) {
    const match = str.match(/\[(.*?)\]/);
    return match ? match[1] : null;
  }

  let rushSelector;
  // Raw production_business_days for the selected rush tier, synced from the checked radio's
  // data-production-business-days and submitted as its own cart line item property (see
  // rushItem.properties below) so ops can see it without decoding the rush date estimate. Blank
  // for tiers with no production_business_days.
  let selectedRushBusinessDays = "";

  if (rushSection) {
    rushSelector = document.querySelector(".rushSelect");

    const rushRadios = document.querySelectorAll('input[name="rushCreation"]');
    const rushTypeLabel = document.getElementById("rushTypeLabel");
    const rushDate = document.getElementById("rushDate");
    const rushContainer = document.querySelector(".label_rushdate_cont");

    const shippingLabel = rushContainer.dataset.shippingLabel;
    rushRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        // sync with hidden select
        rushSelector.value = radio.value;
        rushSelector.dispatchEvent(new Event("change"));

        // get weeks & name
        const weeks = parseInt(radio.dataset.weeks);
        const name = radio.dataset.name;
        selectedRushBusinessDays = radio.dataset.productionBusinessDays || "";

        // calc date
        const today = new Date();
        today.setDate(today.getDate() + weeks * 7);
        const options = { weekday: "short", month: "short", day: "numeric" };
        const formattedDate = today.toLocaleDateString("en-US", options);

        // update label (rush type name)
        rushTypeLabel.textContent = `${name}:`;

        // show metafield text + date
        if (formattedDate) {
          rushDate.innerHTML = `<strong>${shippingLabel} ${formattedDate}</strong>`;
        } else {
          rushDate.textContent = "";
        }
      });
    });
  }

  if (rushSection) {
    nextButtonRushSection.addEventListener("click", (event) => {
      event.preventDefault();
      if (rushSelector.value.trim() !== "") {
        step6.classList.remove("disabled");
        step6.scrollIntoView({ behavior: "smooth" });
      } else {
        event.preventDefault();
        alert("Please select rush creation time");
        rushSection.scrollIntoView({ behavior: "smooth" });
        return;
      }
    });
  }

  function isAnySelected(elements) {
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].classList.contains("selected")) {
        return true;
      }
    }
    return false;
  }

  function isPetTypeAvailable(selectedPetType, options) {
    // Iterate over each item in the productOptions array
    for (var i = 0; i < options.length; i++) {
      var option = options[i];

      // Check if the current option object contains the selected pet type
      if (selectedPetType in option) {
        var petType = option[selectedPetType];

        // Iterate over each position dynamically
        for (var position in petType) {
          if (
            petType.hasOwnProperty(position) &&
            typeof petType[position] === "object"
          ) {
            // Check if the position has the display property set to true
            if (petType[position].display == true) {
              return true; // At least one position is not displayed
            }
          }
        }

        return false; // All positions are displayed
      }
    }

    return false; // Pet type not found
  }

  const petData = C.customizer[4].product_options[1];
  function handleEarImages(petName) {
    const earImagesContainer = document.getElementById("earImagesContainer");

    let pet_data = C.customizer[3].pet_info[2];

    if (petName) {
      const selectedPetOptions = pet_data[petName];

      const earPositions = selectedPetOptions.ear_position;
      const earPostionLabel = selectedPetOptions.ear_positions_heading;

      if (Object.keys(earPositions).length) {
        // Check if ear positions are available for the selected pet type
        const rightEarPositions = earPositions.Right;
        const leftEarPositions = earPositions.Left;

        if (rightEarPositions && leftEarPositions) {
          // Clear existing content inside the earImagesContainer
          earImagesContainer.innerHTML = "";
          // Create HTML elements for right ear positions
          const earPositionLabel = document.createElement("h3");
          earPositionLabel.textContent = earPostionLabel;
          earPositionLabel.id = "ear-position-heading";
          earPositionLabel.classList.add("ear-section-heading");

          const earPositionDiv = document.createElement("div");
          earPositionDiv.classList.add("ear-images");

          const rightColDiv = document.createElement("div");
          rightColDiv.classList.add("ear-tab-content");
          rightColDiv.id = "right-col";
          rightColDiv.style.display = "none";

          const rightLabel = document.createElement("p");
          rightLabel.classList.add("right-label");
          rightLabel.textContent = "Right";
          rightEarPositions.forEach((position) => {
            const label = document.createElement("label");
            const input = document.createElement("input");
            const newDiv = document.createElement("div");
            const imageValue = document.createElement("p");
            imageValue.textContent = position.value;
            imageValue.classList.add("imagePositionValue");
            newDiv.classList.add("ear-label");
            input.id = "right-ear-position";
            input.type = "radio";
            input.name = "properties[_pet_right_ear]";
            input.tabIndex = -1;
            input.value = position.value;
            const img = document.createElement("img");
            img.src = position.src;
            img.alt = position.alt;
            label.addEventListener("click", function () {
              setEarPosition("right", position.value);
            });
            img.setAttribute(
              "aria-label",
              `${rightLabel.textContent} ${earPostionLabel} ${position.alt}`,
            );
            img.setAttribute("tabindex", "0");
            img.addEventListener("keydown", handlePetEarKeyDown);
            label.appendChild(input);
            newDiv.appendChild(img);
            label.appendChild(newDiv);
            label.appendChild(imageValue);
            rightColDiv.appendChild(label);
          });

          // Create HTML elements for left ear positions
          const leftColDiv = document.createElement("div");
          leftColDiv.classList.add("ear-tab-content");
          leftColDiv.id = "left-col";
          leftColDiv.style.display = "flex"; // show left by default
          const leftLabel = document.createElement("p");
          leftLabel.classList.add("left-label");
          leftLabel.textContent = "Left";
          leftEarPositions.forEach((position) => {
            const label = document.createElement("label");
            const input = document.createElement("input");
            const newDiv = document.createElement("div");
            const imageValue = document.createElement("p");
            imageValue.textContent = position.value;
            imageValue.classList.add("imagePositionValue");

            newDiv.classList.add("ear-label");
            input.id = "left-ear-position";
            input.type = "radio";
            input.name = "properties[_pet_left_ear]";
            input.value = position.value;
            input.tabIndex = -1;
            const img = document.createElement("img");
            img.src = position.src;
            img.alt = position.alt;
            label.addEventListener("click", function () {
              setEarPosition("left", position.value);
            });
            img.setAttribute(
              "aria-label",
              `${leftLabel.textContent} ${earPostionLabel} ${position.alt}`,
            );
            img.setAttribute("tabindex", "0");
            img.addEventListener("keydown", handlePetEarKeyDown);
            label.appendChild(input);
            newDiv.appendChild(img);
            label.appendChild(newDiv);
            label.appendChild(imageValue);
            leftColDiv.appendChild(label);
          });

          // Create toggle wrapper
          const earToggleContainer = document.createElement("div");
          earToggleContainer.classList.add("ear-toggle-select");
          // Create toggle text
          const earToggleLabel = document.createElement("p");
          earToggleLabel.id = "different-ear-position-label";
          earToggleLabel.textContent =
            "Select if each of your pet’s ears are different";
          // Create switch wrapper
          const earSwitchLabel = document.createElement("label");
          earSwitchLabel.classList.add("ear-switch");
          earSwitchLabel.setAttribute("tabindex", "0");
          earSwitchLabel.addEventListener("keydown", handle_EarToggle_Keydown);

          const earSwitchInput = document.createElement("input");
          earSwitchInput.id = "different-ear-position";
          earSwitchInput.setAttribute("aria-label", "different-ear-position");
          earSwitchInput.type = "checkbox";
          earSwitchInput.onchange = function () {
            handleEarToggle(this);
          };
          const earSlider = document.createElement("span");
          earSlider.classList.add("ear-slider");
          // Assemble the switch
          earSwitchLabel.appendChild(earSwitchInput);
          earSwitchLabel.appendChild(earSlider);
          // Add text + switch to container
          earToggleContainer.appendChild(earToggleLabel);
          earToggleContainer.appendChild(earSwitchLabel);

          // Create tab buttons container
          const earTabsParent = document.createElement("div");
          earTabsParent.classList.add("earTabs-Parent");
          const earTabs = document.createElement("div");
          earTabs.classList.add("ear-tabs");

          const leftTabBtn = document.createElement("button");
          leftTabBtn.type = "button";
          leftTabBtn.textContent = "Left Ear";
          leftTabBtn.className = "ear-tablink active"; // make left active by default
          leftTabBtn.onclick = function () {
            openEarTab(event, "left-col");
          };

          const rightTabBtn = document.createElement("button");
          rightTabBtn.type = "button";
          rightTabBtn.textContent = "Right Ear";
          rightTabBtn.className = "ear-tablink";
          rightTabBtn.onclick = function () {
            openEarTab(event, "right-col");
          };

          earTabs.appendChild(leftTabBtn);
          earTabs.appendChild(rightTabBtn);

          earTabsParent.appendChild(earTabs);

          // Append the created elements to earImagesContainer
          earPositionDiv.appendChild(leftColDiv);
          earPositionDiv.appendChild(rightColDiv);
          earImagesContainer.appendChild(earPositionLabel);
          earImagesContainer.appendChild(earToggleContainer);
          earImagesContainer.appendChild(earTabsParent);
          earImagesContainer.appendChild(earPositionDiv);
          earImagesContainer.style.display = "flex";
        } else {
          // Hide the entire "Ear Position" section if ear positions are not available
          earImagesContainer.style.display = "none";
          earImagesContainer.innerHTML = "";
        }
      }
    } else {
      earImagesContainer.style.display = "none";
      earImagesContainer.innerHTML = "";
    }
  }
  const formInput = document.getElementById("formId");
  const zipperInput = document.querySelector("#zipperHiddenInput");

  function zipperPouchCheckbox(checkbox) {
    let data = C.plushProduct;

    if (checkbox.checked) {
      zipperInput.value = true;
      // If the checkbox is checked and the title is included, set the form input value to the corresponding ID
      formInput.value = data.variants.find(
        (variant) => variant.title === "Included",
      ).id;
    } else {
      zipperInput.value = false;

      // If the checkbox is not checked, set a default value
      formInput.value = data.variants.find(
        (variant) => variant.title === "Not Included",
      ).id;
    }
  }

  // Handle for custom bandana image swap
  document.addEventListener("change", function (e) {
    const select = e.target;
    if (!select || !select.classList.contains("custom_bandana_select")) {
      return;
    }

    const selectedOption = select.selectedOptions[0];
    if (!selectedOption) return;

    const newImageUrl = selectedOption.dataset.variantImage;
    if (!newImageUrl || newImageUrl.trim() === "") {
      return;
    }
    // found only custom_bandana card image
    const img = document.querySelector(".custom_bandana_body .zipper-image");
    if (!img) return;

    // Smooth fade effect
    img.style.opacity = "0";
    img.style.transition = "opacity 0.1s ease";
    img.src = newImageUrl + "?v=" + Date.now();

    img.onload = () => (img.style.opacity = "1");
    img.onerror = () => (img.style.opacity = "1");
  });

  let products = C.customizer[5].final_options.products;

  let originalUniqueKey = document.querySelector("#originalUniqueKey").value;

  // Cart adds go through fetch only — block native /cart/add submits and
  // implicit submission (Enter in a text field clicks the default submit
  // button), which could add the product to the cart unexpectedly (e.g. while
  // interacting with the size chart).
  var customizerFormEl = document.getElementById("customizer_form");
  if (customizerFormEl) {
    customizerFormEl.addEventListener("submit", function (e) {
      e.preventDefault();
    });
    customizerFormEl.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target && e.target.tagName === "INPUT") {
        e.preventDefault();
      }
    });
  }

  $("#add_to_cart").on("click", function (event) {
    event.preventDefault();
    let addBtn = document.getElementById("add_to_cart");
    addBtn.disabled = true;
    addBtn.style.cssText = "opacity:0.3;pointer-events:none;cursor:not-allowed";
    const originalText = addBtn.textContent;
    addBtn.textContent = "Adding...";

    var shopifyCartUrl = `${window.location.origin}/cart/add.js`;

    var checkboxStatus = {};
    var itemsArray = [];
    var itemQuantity = document.getElementById("final_quantity").value;
    var checkedWithoutSelect = false;

    if (products) {
      for (let i = 0; i < products.length; i++) {
        var productName = products[i].name;

        // Get the selected dropdown value
        var selectedDropdown = document.querySelector(
          "." + productName + "_select",
        );

        var selectedIndex;
        var selectedValue;

        if (selectedDropdown !== null) {
          selectedIndex = selectedDropdown.selectedIndex;
          selectedValue = selectedDropdown.value;
        }

        // Assign values to variables with dynamic names
        var selectedIndexVarName = productName + "_selectedIndex";
        var selectedValueVarName = productName + "_selectedValue";
        window[selectedIndexVarName] = selectedIndex;
        window[selectedValueVarName] = selectedValue;

        // Get all checkbox elements
        var checkbox = document.querySelectorAll(
          "." + productName + "_checkbox",
        );

        checkbox.forEach(function (checkbox) {
          // Get the value of the checkbox
          var value = checkbox.value;
          var status = checkbox.checked ? "checked" : "unchecked";
          checkboxStatus[productName] = status;

          if (
            status === "checked" &&
            (!selectedDropdown || selectedIndex === 0) &&
            selectedDropdown !== null
          ) {
            alert("Please select " + productName + " Variant");
            addBtn.disabled = false;
            addBtn.style.cssText =
              "opacity:1;pointer-events:auto;cursor:pointer";
            addBtn.textContent = "ADD TO CART";
            checkedWithoutSelect = true;
            return;
          } else {
            if (status === "checked" && selectedDropdown !== null) {
              if (productName === "rush") {
                var item = {
                  quantity: itemQuantity,
                  id: window[selectedValueVarName],
                  properties: {
                    _unique_key: originalUniqueKey,
                    _rush_product: true,
                  },
                };
              } else {
                if (
                  productName === "zipper_pouch" ||
                  productName === "heartbeat_box" ||
                  productName === "bobblehead_giftBox" ||
                  productName === "weighted_insert" ||
                  productName === "breathing_box" ||
                  productName === "bobblehead_display_stand" ||
                  productName === "sneak_preview" ||
                  productName === "magnet_giftBox"
                ) {
                  var item = {
                    quantity: itemQuantity,
                    id: window[selectedValueVarName],
                    properties: {
                      _unique_key: originalUniqueKey,
                      _accessories_product: true,
                      _accessories_product_info: selectedPetTypeName,
                    },
                  };
                } else {
                  var item = {
                    quantity: itemQuantity,
                    id: window[selectedValueVarName],
                    properties: {
                      _unique_key: originalUniqueKey,
                      _accessories_product: true,
                      _accessories_product_info:
                        productName === "custom_bandana"
                          ? document.querySelector("#petname").value
                          : selectedPetTypeName,
                      text:
                        productName === "custom_bandana"
                          ? document.querySelector("#petname").value
                          : "",
                    },
                  };
                }
              }
              itemsArray.push(item);
            } else if (
              status === "checked" &&
              selectedDropdown === null &&
              productName !== "cuddle_crate"
            ) {
              document.getElementById(productName).value = "Yes";
              let inputValue = document.querySelector(".input_" + productName);
              var item = {
                quantity: itemQuantity,
                id: inputValue.value,
                properties: {
                  _unique_key: originalUniqueKey,
                  _accessories_product: true,
                  _accessories_product_info:
                    productName === "bobblehead_display_stand"
                      ? document.querySelector("#petname").value
                      : selectedPetTypeName,
                  text:
                    productName === "bobblehead_display_stand"
                      ? document.querySelector("#petname").value
                      : "",
                },
              };
              itemsArray.push(item);
            } else if (
              status === "checked" &&
              selectedDropdown === null &&
              productName === "cuddle_crate"
            ) {
              let cuddleCrateHiddenInput =
                document.querySelector(".cuddleCrateInput");
              if (cuddleCrateHiddenInput) {
                cuddleCrateHiddenInput.value = "Yes";
              }
              let inputValue = document.querySelector(".input_" + productName);
              var item = {
                quantity: itemQuantity,
                id: inputValue.value,
                properties: {
                  _unique_key: originalUniqueKey,
                  _accessories_product: true,
                  _accessories_product_info: selectedPetTypeName,
                },
              };
              itemsArray.push(item);
            }
          }
        });
      }
    }

    let rushSelect = document.querySelector(".rushSelect");
    const rushValue = rushSelect ? String(rushSelect.value || "").trim() : "";

    if (rushSelect && rushValue !== "" && rushSelect.selectedIndex > 0) {
      var rushItem = {
        quantity: itemQuantity,
        id: rushValue,
        properties: {
          _rush_product: true,
          _unique_key: originalUniqueKey,
          "Business Days": selectedRushBusinessDays,
        },
      };
      itemsArray.push(rushItem);
    }

    // Call the function
    if (!checkedWithoutSelect) {
      addToCart(itemsArray, shopifyCartUrl);
    } else {
      return;
    }

    async function addToCart(itemsArray, shopifyCartUrl) {
      try {
        const formData = $("#customizer_form").serializeArray();

        let mainItemId = null;

        const primaryProduct = formData.reduce((acc, { name, value }) => {
          const match = name.match(/^properties\[(.+?)\]$/);

          if (match) {
            const extractedName = match[1];

            if (acc[extractedName]) {
              if (Array.isArray(acc[extractedName])) {
                acc[extractedName].push(value);
              } else {
                acc[extractedName] = [acc[extractedName], value];
              }
            } else {
              acc[extractedName] = value;
            }
          } else if (name === "id") {
            mainItemId = value;
          }
          return acc;
        }, {});

        const mainItem = {
          quantity: itemQuantity || 1,
          id: mainItemId,
          properties: { ...primaryProduct },
        };

        itemsArray.unshift(mainItem);

        const combinedItems = itemsArray
          .filter(
            (item) =>
              item &&
              item.id !== undefined &&
              item.id !== null &&
              String(item.id).trim() !== "",
          )
          .map((item) => ({
            quantity: item.quantity || 1,
            id: item.id,
            properties: item.properties || {},
          }));

        const combinedOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: combinedItems }),
        };
        const response = await fetch(shopifyCartUrl, combinedOptions);

        if (response.ok) {
          window.location.href = `${C.shopUrl}/cart`;
        } else {
          const errorPayload = await response.text();
          console.error(
            "Cart add failed",
            response.status,
            errorPayload,
            combinedItems,
          );
          if (response.status === 422) {
            const safeItems = combinedItems.filter((item) => {
              if (String(item.id) === String(mainItemId)) return true;
              return item.properties && item.properties._rush_product === true;
            });
            if (safeItems.length > 0) {
              const retryResponse = await fetch(shopifyCartUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: safeItems }),
              });
              if (retryResponse.ok) {
                alert(
                  "Some add-ons are unavailable on this store and were skipped.",
                );
                window.location.href = `${C.shopUrl}/cart`;
                return;
              }
            }
          }
          addBtn.disabled = false;
          addBtn.style.cssText = "opacity:1;pointer-events:auto;cursor:pointer";
          addBtn.textContent = originalText;
          alert("Failed to add to cart. Please try again.");
        }
      } catch (error) {
        console.error("An error occurred in the addToCart function:", error);
      }
    }
  });

  if (products) {
    for (let i = 0; i < products.length; i++) {
      var product = products[i];
      var productName = product.name;
      let mainCheckboxes = document.querySelectorAll(
        `.${productName}_checkbox`,
      );

      // dependency Logic
      if (product.detail.dependency?.length > 0) {
        product.detail.dependency.forEach(function (item) {
          const itemName = item.product_name;
          const itemMessage = item.message;
          const itemCheckboxes = document.querySelectorAll(
            `.${itemName}_checkbox`,
          );

          mainCheckboxes.forEach(function (mainCheckbox) {
            mainCheckbox.addEventListener("change", function () {
              if (mainCheckbox.checked) {
                itemCheckboxes.forEach(function (itemCheckbox) {
                  if (!itemCheckbox.checked) {
                    itemCheckbox.checked = true;
                    alert(itemMessage);
                  }
                });
              }
            });
          });
          // if user tries to uncheck the dependent product then forcefully check the dependent product if main product is checked
          itemCheckboxes.forEach(function (itemCheckbox) {
            itemCheckbox.addEventListener("change", function () {
              mainCheckboxes.forEach(function (mainCheckbox) {
                if (mainCheckbox.checked && !itemCheckbox.checked) {
                  itemCheckbox.checked = true;
                }
              });
            });
          });
        });
      }
      // Incompatibility Logic
      if (product.detail.incompatibility?.length > 0) {
        product.detail.incompatibility.forEach(function (item) {
          const incompatibleName = item.product_name;
          const incompatibilityMessage = item.message;
          const incompatibleCheckboxes = document.querySelectorAll(
            `.${incompatibleName}_checkbox`,
          );

          mainCheckboxes.forEach(function (mainCheckbox) {
            mainCheckbox.addEventListener("change", function () {
              if (mainCheckbox.checked) {
                incompatibleCheckboxes.forEach(function (incompatibleCheckbox) {
                  if (incompatibleCheckbox.checked) {
                    // Uncheck the incompatible addon
                    incompatibleCheckbox.checked = false;
                    alert(incompatibilityMessage);
                  }
                });
              }
            });
          });
        });
      }
    }
  }

  // ------------Event Listner to validate the bandana field to only accept alphabets
  document.addEventListener("DOMContentLoaded", function () {
    let inputElement = document.querySelector(".bandannaInput");

    inputElement?.addEventListener("input", function (event) {
      let enteredValue = event.target.value;

      // Restrict input to alphabets only and capitalize them
      event.target.value = enteredValue.replace(/[^a-zA-Z]/g, "").toUpperCase();

      // Check if input exceeds 18 characters
      const maxLength = 18;
      if (event.target.value.length > maxLength) {
        alert(`Input cannot exceed ${maxLength} characters.`);
        event.target.value = event.target.value.substring(0, maxLength); // Trim excess characters
      }
    });
  });

  function checkDisplayTrue(obj) {
    for (let key in obj) {
      if (obj[key].display) {
        return true;
      }
    }
    return false;
  }

  // Function to open the popup
  function openPopup() {
    document.getElementById("popup").style.display = "block";
    generateSizeChart(); // Generate size chart tabs and tables
  }

  // Function to close the popup
  function closePopup() {
    document.getElementById("popup").style.display = "none";
  }

  // Function to dynamically generate tabs and tables
  function generateSizeChart() {
    var sizeChartTitle = document.getElementById("sizeChartTitle");
    var sizeChartTabs = document.getElementById("sizeChartTabs");
    var sizeTables = document.getElementById("sizeTables");

    sizeChartTitle.innerHTML = "";
    sizeChartTabs.innerHTML = "";
    sizeTables.innerHTML = "";

    sizeChartTitle.textContent = sizeData.variant_options[0].size_chart.title;

    // Loop through each country in sizeData
    for (var country in sizeData.variant_options[0].size_chart.data) {
      // Generate tab for each country
      var tab = document.createElement("button");
      tab.type = "button";
      tab.className = "tablinks";
      tab.style.fontWeight = "bold";
      tab.textContent = country;
      tab.onclick = (function (countryName) {
        return function (e) {
          openTab(countryName, e.currentTarget);
        };
      })(country);
      sizeChartTabs.appendChild(tab);

      // Generate table for size details of each country
      var table = document.createElement("table");
      table.className = "tabcontent";
      table.id = country;
      var countryData = sizeData.variant_options[0].size_chart.data[country];

      // Create table header row
      var headerRow = table.insertRow();
      var headerCell1 = headerRow.insertCell(0);
      var headerCell2 = headerRow.insertCell(1);
      var headerCell3 = headerRow.insertCell(2);
      headerCell1.textContent = sizeData.variant_options[0].size_chart.key_name;
      headerCell2.textContent = "Female";
      headerCell3.textContent = "Male";
      headerCell1.style.fontWeight = "bold";
      headerCell2.style.fontWeight = "bold";
      headerCell3.style.fontWeight = "bold";
      headerCell1.style.width = "231px";
      headerCell2.style.width = "231px";
      headerCell3.style.width = "231px";

      for (var size in countryData) {
        var row = table.insertRow();
        var cell1 = row.insertCell(0);
        var cell2 = row.insertCell(1);
        var cell3 = row.insertCell(2);
        cell1.textContent = size;
        cell2.textContent = countryData[size].Female;
        cell3.textContent = countryData[size].Male;
      }
      sizeTables.appendChild(table);
    }

    // Show the first tab by default
    var firstTab = sizeChartTabs.querySelector(".tablinks");

    if (firstTab) {
      openTab(firstTab.textContent, firstTab); // Show corresponding table for the first tab
    }
  }
  var tabButtons = document.querySelectorAll(".tablinks");
  tabButtons.forEach(function (button) {
    button.style.width = 100 / tabButtons.length + "%"; // Distribute width equally
  });

  function openTab(tabName, tabBtn) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].classList.remove("active");
    }
    document.getElementById(tabName).style.display = "flex";
    document.getElementById(tabName).style.justifyContent = "center";
    if (tabBtn) tabBtn.classList.add("active");
  }

  function isSizeChartAvailable(data) {
    if (data && data.size === true) {
      return true;
    }
    return false;
  }


  // for keyboard events
  const petImages = Array.from(document.querySelectorAll(".pet-image"));

  function selectPlushFrameOptions(label, class_name, event, value) {
    removeSelectedClassFromChildren(event);

    event.classList.add("selected");
    event.style.border = "5px solid rgb(84, 97, 200)";
    var getHiddenFields = document.getElementsByClassName(class_name);
    if (event.className.includes("frame")) {
      document.getElementById("formId").value = value;
      getHiddenFields[0].value = label;
    } else {
      getHiddenFields[0].value = label;
    }
  }

  function removeSelectedClassFromChildren(event) {
    const className = event.className;
    const selectedOption = document.querySelectorAll(`.${className}.selected`);

    if (selectedOption.length > 0) {
      selectedOption.forEach((child) => {
        child.classList.remove("selected");
        child.style.border = "";
      });
    }
  }
  // for keyboard events
  function handlePetImageKeydown(event) {
    const currentIndex = petImages.indexOf(event.currentTarget);
    const divStep2 = document.querySelector(".step-2");

    if (event.key === "Enter") {
      event.preventDefault();
      petImages[currentIndex].click();
    }

    if (event.key === "ArrowRight" && currentIndex < petImages.length - 1) {
      petImages[currentIndex + 1].focus();
    }

    if (event.key === "ArrowLeft" && currentIndex > 0) {
      petImages[currentIndex - 1].focus();
    }
  }

  function clickImageINput(event) {
    if (event.key !== "Enter") return;
    const zone = event.currentTarget;
    const fileInput =
      zone && zone.querySelector && zone.querySelector(".imageUploader");
    if (fileInput) fileInput.click();
  }

  function eyeColorKeydown(event) {
    const checkbox = document.getElementById("different-eye-color");
    let containers;

    if (checkbox.checked) {
      containers = document.querySelectorAll(
        "#first-palette .color, #second-palette .color",
      );
    } else {
      containers = document.querySelectorAll("#first-palette .color");
    }

    const eyeColors = Array.from(containers);
    const currentIndex = eyeColors.indexOf(event.currentTarget);

    if (event.key === "Enter") {
      event.preventDefault();
      eyeColors[currentIndex].click();
    }

    if (event.key === "ArrowRight" && currentIndex < eyeColors.length - 1) {
      eyeColors[currentIndex + 1].focus();
    }

    if (event.key === "ArrowLeft" && currentIndex > 0) {
      eyeColors[currentIndex - 1].focus();
    }
  }

  function handlePetPositionKeydown(event) {
    const bodyPosition = Array.from(
      document.querySelectorAll(".final-product-positions img"),
    );
    const currentIndex = bodyPosition.indexOf(event.currentTarget);

    if (event.key === "Enter") {
      event.preventDefault();
      bodyPosition[currentIndex].click();
    }
  }

  function handlePetEarKeyDown(event) {
    const EarPosition = Array.from(document.querySelectorAll(".ear-label img"));
    const currentIndex = EarPosition.indexOf(event.currentTarget);

    if (event.key === "Enter") {
      event.preventDefault();
      EarPosition[currentIndex].click();
    }
  }

  function handleImagesDiv(event) {
    if (event.key === "Delete") {
      event.preventDefault();

      const img = event.currentTarget;
      const imageContainer = img.closest(".image-container");
      const deleteButton = imageContainer?.querySelector(".delete-button");

      if (deleteButton) {
        deleteButton.click();
      }
    }
  }

  function handle_DescriptionBox_textarea(event) {
    if (event.key === "Enter") {
      const textarea = Array.from(
        document.querySelectorAll(".DescriptionBox_Container .DescriptionBox"),
      );
      const currentIndex = textarea.indexOf(event.currentTarget);
      event.preventDefault();
      textarea[currentIndex].click();
    }
  }

  function handle_EarToggle_Keydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.currentTarget.click();
    }
  }

  function rushCreationToggle_Keydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.currentTarget.click();
    }
  }

  function EyeColor_ToggleSwitch(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.currentTarget.click();
    }
  }

  function addOnSection_Keydwon(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.currentTarget.click();
    }
  }

  function handleFrameKeyDown(event) {
    const portrait = Array.from(
      document.querySelectorAll(".frame-image-container img"),
    );
    const currentIndex = portrait.indexOf(event.currentTarget);
    if (event.key === "Enter") {
      event.preventDefault();
      portrait[currentIndex].click();
    }
  }

  function handleFrame_BGkeydown(event) {
    const background = Array.from(
      document.querySelectorAll(".background-options-container img"),
    );
    const currentIndex = background.indexOf(event.currentTarget);

    if (event.key === "Enter") {
      event.preventDefault();
      background[currentIndex].click();
    }
  }

  let isPopupOpen = false;
  function handleSizeChartKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      if (isPopupOpen) {
        closePopup();
        isPopupOpen = false;
      } else {
        openPopup();
        isPopupOpen = true;
      }
    }
  }

  // For EyeColor-Pallete Tabs
  function openPalette(evt, paletteId) {
    const tabcontent = document.getElementsByClassName("Palettecontent");
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    const Palettetablinks = document.getElementsByClassName(
      "tablinks-ColorPalette",
    );
    for (let i = 0; i < Palettetablinks.length; i++) {
      Palettetablinks[i].className = Palettetablinks[i].className.replace(
        " active",
        "",
      );
    }

    document.getElementById(paletteId).style.display = "flex";
    evt.currentTarget.className += " active";
  }

  //For EarPosition tabs

  function openEarTab(evt, tabId) {
    const tabcontent = document.getElementsByClassName("ear-tab-content");
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    const tablinks = document.getElementsByClassName("ear-tablink");
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].classList.remove("active");
    }

    document.getElementById(tabId).style.display = "flex";
    evt.currentTarget.classList.add("active");
  }

  function handleEarToggle(checkbox) {
    const earTabs = document.querySelector(".ear-tabs");
    const earleftcol = document.querySelector("#left-col");
    const earrightcol = document.querySelector("#right-col");
    const leftEarInput = document.getElementById("left-ear-position");
    const rightEarInput = document.getElementById("right-ear-position");

    const leftEar = leftEarInput.value;

    if (checkbox.checked) {
      earTabs.style.display = "flex";
      // When ON: user must pick right & left manually, so clear right
      rightEarInput.value = "";
    } else {
      // When OFF: force right to match left if left has value
      earTabs.style.display = "none";
      earleftcol.style.display = "flex";
      earrightcol.style.display = "none";

      if (leftEar) {
        rightEarInput.value = leftEar;
        const rightEarRadios = document.querySelectorAll(
          'input[name="properties[_pet_right_ear]"]',
        );
        rightEarRadios.forEach((input) => {
          input.checked = input.value === leftEar;
        });
      }
    }
  }

  function setEarPosition(earSide, value) {
    const toggle = document.getElementById("different-ear-position");

    // Find and check the selected radio input for the side
    const earInputs = document.querySelectorAll(
      `input[name="properties[_pet_${earSide}_ear]"]`,
    );
    earInputs.forEach((input) => {
      if (input.value === value) {
        input.checked = true;
      }
    });

    // If toggle is OFF, force both sides to match
    if (!toggle.checked) {
      const otherSide = earSide === "left" ? "right" : "left";
      const otherEarInputs = document.querySelectorAll(
        `input[name="properties[_pet_${otherSide}_ear]"]`,
      );
      otherEarInputs.forEach((input) => {
        if (input.value === value) {
          input.checked = true;
        }
      });
    }
  }

  function EyeColorValidate_Other(e) {
    e.preventDefault();

    const leftEyeColorInput = document.getElementById("left-eye-color");
    const rightEyeColorInput = document.getElementById("right-eye-color");

    const leftEyeColor = leftEyeColorInput.value.trim();
    const rightEyeColor = rightEyeColorInput.value.trim();

    const eyeColorsSelected = leftEyeColor !== "" && rightEyeColor !== "";

    if (!eyeColorsSelected) {
      alert("Please select eye colors for both eyes.");
      return;
    }

    if (productOptionDisplay) {
      if (rushSection) {
        rushSection.classList.remove("disabled");
        rushSection.scrollIntoView({ behavior: "smooth" });
      } else {
        step6.classList.remove("disabled");
        step6.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      if (rushSection) {
        rushSection.classList.remove("disabled");
        rushSection.scrollIntoView({ behavior: "smooth" });
      } else {
        step6.classList.remove("disabled");
        step6.scrollIntoView({ behavior: "smooth" });
      }
    }
  }

  document
    .querySelectorAll('.rush-toggle input[type="radio"]')
    .forEach((radio) => {
      radio.addEventListener("change", function () {
        const container = this.closest(".main_content_rush_container");
        if (container) {
          // animation reset trick
          container.classList.remove("animate-zoom");
          void container.offsetWidth;
          container.classList.add("animate-zoom");
        }
      });
    });

  // Progress Bar Logic
  const stepsMapping = [
    { class: ".step_SpecieType", step: 1 },
    { class: ".step2", step: 2 },
    { class: ".step3", step: 3 },
    { class: ".step4", step: 4 },
    { class: ".rushContainer_Parent", step: 5 },
    { class: ".step6", step: 6 },
  ];

  function barUpdateProgress() {
    let currentStep = 0;
    stepsMapping.forEach((mapping) => {
      const section = document.querySelector(mapping.class);
      if (section && !section.classList.contains("disabled")) {
        currentStep = Math.max(currentStep, mapping.step);
      }
    });

    document.querySelectorAll(".step").forEach((step, index) => {
      const stepNum = parseInt(step.dataset.step);
      const circle = step.querySelector(".step-circle");

      if (stepNum < currentStep) {
        circle.classList.add("completed");
        step.classList.add("active");
      } else if (stepNum === currentStep) {
        circle.classList.remove("completed");
        step.classList.add("active");
      } else {
        circle.classList.remove("completed");
        step.classList.remove("active");
      }

      if (index === 0) {
        step.classList.add("active");
      }
    });
  }

  // Navigate to the section corresponding to the clicked step
  function navigateToStep(stepNum) {
    const mapping = stepsMapping.find((mapping) => mapping.step === stepNum);
    if (mapping) {
      const section = document.querySelector(mapping.class);
      if (section && !section.classList.contains("disabled")) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }

  // MutationObserver to watch for class changes (when 'disabled' is removed)
  const observer = new MutationObserver(barUpdateProgress);
  const config = { attributes: true, attributeFilter: ["class"] };

  stepsMapping.forEach((mapping) => {
    const section = document.querySelector(mapping.class);
    if (section) {
      observer.observe(section, config);
    }
  });

  barUpdateProgress();

  // Add click event listeners to each step
  document.querySelectorAll(".step").forEach((step) => {
    step.addEventListener("click", () => {
      const stepNum = parseInt(step.dataset.step);
      navigateToStep(stepNum);
    });
  });

  // Also update on scroll or button clicks if needed
  window.addEventListener("scroll", barUpdateProgress);

  // Progress bar visibility already set at top from C.progressBarVisible (metafield progress_bar).

  function skipImageUplaod(event) {
    let imageUplaoder = document.querySelector(".skipUpload");
    let step4 = document.querySelector(".step4 ");

    let step5 = document.querySelector(".step5 ");
    let imagePreview = document.getElementById("preview");

    if (step4 && step5) {
      step4.scrollIntoView({ behavior: "smooth" });
      step4.classList.remove("disabled");
      step5.classList.remove("disabled");
    }

    if (imagePreview) {
      imagePreview.innerHTML = "";
    }
  }

  // Expose handlers for inline onclick/onchange in Liquid
  window.selectedPetType = selectedPetType;
  window.scrollToElement = scrollToElement;
  window.dragNdrop = dragNdrop;
  window.drag = drag;
  window.drop = drop;
  window.clickImageINput = clickImageINput;
  window.step3DragOver = step3DragOver;
  window.step3Drop = step3Drop;
  window.validatePlushCloneOptions = validatePlushCloneOptions;
  window.decreaseQuantity = decreaseQuantity;
  window.increaseQuantity = increaseQuantity;
  window.showHideSecondPalette = showHideSecondPalette;
  window.setEyeColor = setEyeColor;
  window.closePopup = closePopup;
  window.selectPlushFrameOptions = selectPlushFrameOptions;
  window.handleFrameKeyDown = handleFrameKeyDown;
  window.handleFrame_BGkeydown = handleFrame_BGkeydown;
  window.openPalette = openPalette;
  window.skipImageUplaod = skipImageUplaod;
})();
